<template>
  <div class="participant_content participant-bg" @click="hideModal()">
    <div class="modal fade" v-if="eligibilityScreenQuestionsAnsOfParticipnt" id="eligibilityScreenQuestionsAns" tabindex="-1">
      <div class="transfer-modal-dialog modal-dialog">
        <div class="modal-w-h-style modal-content p-0 m-0">
          <div class="modal-header header-rectangle border-none m-0 p-0">
            <p class="agreement-accepted-style m-0 mr-45 mt-14 p-0">
              Agreement Accepted on
              <span v-if="agreementAcceptedDate">{{ agreementAcceptedDate }} at {{ agreementAcceptedTime }} UTC </span>
            </p>
            <select class="lang-slection-style" name="language" v-model="selectedLang">
              <option :value="undefined" selected="selected" disabled>Select</option>
              <option>{{ getLanguageText(displayLanguage) }}</option>
            </select>
            <button type="button" class="close-btn" data-dismiss="modal">x</button>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="eligibility-heading-style">Eligibility Responses</div>
            <div class="row margin-style-2 p-0">
              <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pl-0 mb-8 mt-8 question-answer-style-heading">
                QUESTION
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0 mb-8 mt-8 question-answer-style-heading">
                ANSWER
              </div>
            </div>
            <div v-if="isLoading === true" class="loading-style">
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </div>
            <div v-if="isLoading === false" class="question-wrapper">
              <div class="row margin-style-1 p-0 gray-color" v-for="(queAndAns, index) in eligibilityScreenQuestionsAnsOfParticipnt" :key="index">
                <div class="d-flex col-xs-8 col-sm-8 col-md-8 col-lg-8 pl-0">
                  <span class="pr-14">{{ index + 1 }}.</span>
                  <span v-html="queAndAns.question"></span>
                </div>
                <div v-if="queAndAns.question_type === 'MultiChoiceQuestion'" v-html="queAndAns.answer_text" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0"></div>
                <div v-if="queAndAns.question_type === 'BooleanQuestion'" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0">
                  {{ queAndAns.answer_text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Participant transfer modal  -->
    <div class="modal fade" id="siteIdModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" v-if="participantTransfer">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body m-0 p-3">
            <div class="transfer-modal-title">Select a Site to Transfer Participant</div>
            <div class="siteId-box mt-13">
              <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Enter site name or ID" v-model="searchedSite" />
              <div class="page-modal mt-5">
                <div class="wrapper">
                  <div class="content" v-if="studyData">
                    <div class="select-scroll activity-builder-select-options" v-for="site in searchedSitesList" :key="site.userSiteId">
                      <div v-on:click="selectSiteToTransfer(site)" class="selectedSite d-flex" :id="'selectedSite' + site.userSiteId">
                        <label class="Site-ID">{{ site.userSiteId }} </label>
                        <label :for="site.userSiteId" class="Site-Name">{{ site.name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-dropdown mt-18 w-298">
              <div class="form-group" style="margin-bottom: 0px !important;">
                <div id="siteIdSelectBox" class="multiselect filter-form-box">
                  <div class="selectBox" @click="showSiteTransferReason">
                    <div class="fakeclass nsiteId-input">
                      <input name="siteId" :value="newSiteTransferReason" id="select-question" readonly placeholder="Select a reason for the change" :tabindex="10" class="form-control input-md th-comman-select-box" />
                    </div>

                    <div class="overSelect"></div>
                  </div>
                  <div id="showSiteTransferReason" class="select-scroll activity-builder-select-options" v-if="isSiteTransferReason">
                    <label data-v-2f4812d0="" id="Notification-value" class="pi-width notificationLabel pl-6" v-for="(reason, index) in listOfSiteTransferReason" :value="reason.value" :key="index" @click="onSiteTransferReasonClick(reason.value)">
                      {{ reason.name }}
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="newSiteTransferReason == 'Other'" class="fakeclass siteId-input">
                <textarea type="text" class="form-control py-2 my-2" v-model="userReasonForOther" placeholder="Enter reason for change"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class=" btn fs-12 btn-default btn-cancel-default" data-dismiss="modal">Cancel</button>
            <button type="button" class="modal-btn btn fs-12 btn-primary btn-continue-prim" data-toggle="modal" data-target="#demo-2" data-dismiss="modal" @click="getSelectedParticipants()" :disabled="!checkAllConditions()">Continue</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Demo Second modal correct -->
    <div class="modal fade siteIdModel-2" id="demo-2" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p class="question-title">
              Are you sure you want to transfer the following participant to site
              <span class="d-block"
                ><b>{{ newSite.userSiteId }} - {{ newSite.name }}</b></span
              >
            </p>
            <div class="participant-info">
              <div class="wrapper">
                <div class="row fs-12">
                  <div class=" col-md-5 text-lightGray">Participant ID</div>
                  <div class=" col-md-7 text-lightGray">THREAD ID</div>
                </div>

                <div class="row" v-for="(participant, index) in participantsDataForModal" :key="index">
                  <div class="col-md-5 fs-14">
                    <span v-if="participant.userDefinedParticipantId" v-html="convertArrayStringHtml('', participant.userDefinedParticipantId)"></span>
                    <span v-else>{{ truncateUserDefinedParticipantId(participant.userDefinedParticipantId) }}</span>
                  </div>
                  <div class="col-md-7 fs-14">{{ truncateUserDefinedParticipantId(participant.id) }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex pt-28 justify-content-center">
              <div><button type="button" class="btn btn-1 fs-14  mr-22" data-dismiss="modal" @click="emtpyDataForModal">No</button></div>
              <div><button type="button" @click="sendSiteDataToTransfer()" class="btn btn-2 fs-14">Yes</button></div>
            </div>
            <p class="note"><b>Note: &nbsp;</b>Approval of the transfer is required by the site team of the receiving site.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="changeScreeningStatus" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content p-20">
          <div class="modal-header border-none m-4 p-0">
            <p class="change-screening-status m-0 p-0">Change participant screening status</p>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="rectangle">
              <div class="field-wrapper">
                <p class="participant-ID">Participant ID</p>
                <p class="participant-ID-field">{{ selectedParticipantForChangeStatusValue.userDefinedParticipantId }}</p>
              </div>
              <div class="field-wrapper">
                <p class="thread-ID">THREAD ID</p>
                <p class="thread-ID-field">{{ selectedParticipantForChangeStatusValue.id }}</p>
              </div>
            </div>
          </div>
          <div v-if="!selectedScreenFailure" class="modal-footer justify-content-center mt-8 mb-6 m-4 p-0">
            <button type="button" class="cancel-modal-but" data-dismiss="modal" v-on:click="resetSelectedParticipant">
              <span>Cancel</span>
            </button>
            <button type="button" class="screening-failed-but" v-on:click="addScreenFailure(this)">
              <span class="screening-failed-span">Screening failed</span>
            </button>
            <button type="button" class="screening-passed-but" data-toggle="modal" data-target="#inviteParticipantNow" data-dismiss="modal" v-on:click="screeningPassed(selectedParticipantForChangeStatusValue.id, selectedParticipantForChangeStatusValue.email, selectedParticipantForChangeStatusValue.siteId)">
              <span class="screening-passed-span">Screening passed</span>
            </button>
          </div>
          <div v-if="selectedScreenFailure" class="text-secondary mt-8 mb-6 m-4 p-0">
            <p class="participant-static-text">
              Participant has failed screening. You can select a reason for failure below or simply confirm to change status.
            </p>
            <b-row class="d-flex justify-content-center">
              <b-col cols="8">
                <b-form-checkbox-group v-model="screenFailureReasons" :options="secreenFailureOptions" value-field="value" text-field="text" name="flavour-2a" class="multi-reasons-list" stacked></b-form-checkbox-group>
                <span :class="checkTextArea" v-if="checkOtherReason">
                  <b-form-textarea class="custom-other-textarea" placeholder="Enter a reason for failure" rows="3" name="Other" maxlength="100" v-validate="'required|min:3|max:100'" v-model="otherScreenFailureReasons"> </b-form-textarea>
                </span>
                <p v-show="errors.has('Other')" class="error">{{ errors.first("Other") }}</p>
              </b-col>
            </b-row>
            <div class="modal-footer justify-content-center mt-8 mb-6 m-4 p-0">
              <button type="button" class="cancel-modal-but" v-on:click="hideScreenFailureReasons(this)">
                <span>Cancel</span>
              </button>
              <button :class="isConfirmButtonDisable() ? 'disable-confirm' : 'screening-passed-but'" :disabled="isConfirmButtonDisable()" @click.stop="screeningFailed(selectedParticipantForChangeStatusValue.id, selectedParticipantForChangeStatusValue.email, selectedParticipantForChangeStatusValue.siteId)">
                <span class="screening-failed-span">Confirm</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---Modal screen failure----->
    <div class="modal fade " v-if="failureReasons" id="screenFailureResons" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content ">
          <div class="modal-header border-none m-0 p-0">
            <p class="reasons-modal-title m-0 p-3">Reasons for {{ selectedReason }}</p>
            <button type="button" class="close" @click="closeScreenFailureModal">&times;</button>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="screen-failure">
              <div class="failure-reasons" v-if="failureReasons">
                <ul>
                  <li v-for="(reasons, index) in failureReasons.reasons" :key="index">{{ reasons }}</li>
                  <li v-if="failureReasons && failureReasons.other">
                    Other
                    <p class="other-failure-reasons">{{ failureReasons.other }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="inviteParticipantNow" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content p-20">
          <div class="modal-header border-none m-4 p-0">
            <p class="change-screening-status m-0 p-0">Change participant screening status</p>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="rectangle">
              <div class="field-wrapper">
                <p class="participant-ID">Participant ID</p>
                <p class="participant-ID-field" v-if="selectedParticipantForChangeStatusValue.userDefinedParticipantId">{{ selectedParticipantForChangeStatusValue.userDefinedParticipantId }}</p>
              </div>
              <div class="field-wrapper">
                <p class="thread-ID">THREAD ID</p>
                <p class="thread-ID-field" v-if="selectedParticipantForChangeStatusValue.id">
                  {{ selectedParticipantForChangeStatusValue.id }}
                </p>
              </div>
            </div>
          </div>
          <div class="row invite-que-style m-4 p-0">
            <div class="col text-center font-weight-bold">Participant has passed screening</div>
            <div class="col text-center">Do you want to send as invite ?</div>
          </div>
          <div class="modal-footer justify-content-center m-4 p-0">
            <button type="button" class="cancel-modal-but" data-dismiss="modal" v-on:click="resetSelectedParticipant">
              <span>Invite later</span>
            </button>
            <button type="button" class="screening-passed-but" data-dismiss="modal" v-on:click="invitedParticipant(selectedParticipantForChangeStatusValue.id, selectedParticipantForChangeStatusValue.email, selectedParticipantForChangeStatusValue.siteId)">
              <span class="screening-passed-span">Invite Now</span>
            </button>
            <button type="button" class="active-without-app-but" data-dismiss="modal" v-on:click="activeWithoutAppParticipant(selectedParticipantForChangeStatusValue.id, selectedParticipantForChangeStatusValue.email, selectedParticipantForChangeStatusValue.siteId)"><span>Activate without App</span></button>
          </div>
        </div>
      </div>
    </div>
    <nav v-if="canResearchSiteTeamAccess && composeMessageId" aria-label="breadcrumb" class="participant-breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'study-participant-messages' }">Messages</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'study-participant-compose-message', params: { composeMessageId: composeMessageId } }">Compose Message</router-link>
        </li>
        <li class="breadcrumb-item current-label">
          <span>Select Participants</span>
        </li>
      </ol>
    </nav>
    <!-- from site document breadcrumbs -->
    <nav v-if="canStudyAdminAccess && siteDocumentId" aria-label="breadcrumb" class="participant-breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'list-research-site' }">Research Sites</router-link>
        </li>
        <li class="breadcrumb-item">
          <a @click="$router.go(-1)">Documents</a>
        </li>
        <li class="breadcrumb-item current-label">
          <span>Select Participants</span>
        </li>
      </ol>
    </nav>
    <div class="pl-30 pr-30 ipad_pad_0" :class="{ 'pt-30': !composeMessageId }">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
        <div class="participant-header">
          <div class="row pb-15">
            <span class="color_2d3752 fs-22">
              <b>
                <span v-if="canResearchSiteTeamAccess && composeMessageId">Select Participants</span>
                <span v-if="(canResearchSiteTeamAccess || canStudyAdminAccess) && siteDocumentId">Select Participants</span>
                <span v-else-if="participantTransfer">Move Participants</span>
                <span v-else>My Participants</span>
              </b>
            </span>
          </div>
          <div class="row" style="display:flex">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2 pl-0">
              <div class="form-group has-feedback mb-0">
                <input type="text" class="form-control mb-0 br-3 search-field" placeholder="Search" v-model="searchTerm" @keyup.enter="searchParticipantFilterStudies()" />
              </div>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2 pl-0 fs-14 select_section">
              <select class="form-control mb-0 br-3 input-bg select_control" v-model="filterTerm" v-on:change="searchParticipantFilterStudies()">
                <option disabled value>Status</option>
                <option value>None</option>
                <option :value="getStatuses.ACTIVE">{{ getStatusText({ status: getStatuses.ACTIVE }) }}</option>
                <option v-if="feature.length !== 0" :value="getStatuses.ACTIVEWMODIFICATION">{{
                  getStatusText({
                    status: getStatuses.ACTIVEWMODIFICATION
                  })
                }}</option>
                <option :value="getStatuses.REGISTERED">{{ getStatusText({ status: getStatuses.REGISTERED }) }}</option>
                <option :value="getStatuses.VERIFIED">{{ getStatusText({ status: getStatuses.VERIFIED }) }}</option>
                <option v-if="studyData.onboardingType !== 'OpenEnrollment'" :value="getStatuses.INVITED"> {{ getStatusText({ status: getStatuses.INVITED }) }}</option>
                <option v-if="studyData.onboardingType !== 'OpenEnrollment'" :value="getStatuses.NOTINVITED"> {{ getStatusText({ status: getStatuses.NOTINVITED }) }}</option>
                <option v-if="legacyVal" :value="getStatuses.WITHDRAWSTUDY">{{
                  getStatusText({
                    status: getStatuses.WITHDRAWSTUDY
                  })
                }}</option>
                <option v-if="legacyVal" :value="getStatuses.DISQUALIFIED">{{
                  getStatusText({
                    status: getStatuses.DISQUALIFIED
                  })
                }}</option>
                <option v-if="!legacyVal" :value="getStatuses.DISCONTINUED">{{
                  getStatusText({
                    status: getStatuses.DISCONTINUED
                  })
                }}</option>
                <option :value="getStatuses.PRESCREENED">{{ getStatusText({ status: getStatuses.PRESCREENED }) }}</option>
                <option :value="getStatuses.SCREENPASSED">{{ getStatusText({ status: getStatuses.SCREENPASSED }) }}</option>
                <option :value="getStatuses.SCREENING">{{ getStatusText({ status: getStatuses.SCREENING }) }}</option>
                <option :value="getStatuses.SCREENFAILED">{{ getStatusText({ status: getStatuses.SCREENFAILED }) }}</option>
                <option :value="getStatuses.ACTIVEWITHOUTAPP">{{ getStatusText({ status: getStatuses.ACTIVEWITHOUTAPP }) }} </option>
              </select>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4  pl-0 fs-14 select_section" v-bind:class="{ 'col-lg-2': siteDocumentId || composeMessageId, 'col-lg-1': !siteDocumentId || !composeMessageId }">
              <select class="form-control mb-0 br-3 input-bg select_control" v-model="sourcefilter" v-on:change="searchParticipantFilterStudies()">
                <option disabled value>Source</option>
                <option value>None</option>
                <option :value="getSources.WEB">{{ getSourceText({ source: getSources.WEB }) }}</option>
                <option :value="getSources.APP">{{ getSourceText({ source: getSources.APP }) }}</option>
                <option :value="getSources.MANUAL">{{ getSourceText({ source: getSources.MANUAL }) }}</option>
              </select>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2 pl-0 fs-14 select_section" v-if="cohortList.length > 1">
              <select class="form-control mb-0 br-3 input-bg select_control" v-model="cohortFilter" v-on:change="searchParticipantFilterStudies()">
                <option disabled value>eConsent Cohort</option>
                <option value>None</option>
                <option v-for="(item, index) in cohortList" :value="item.cohortId" :key="index">{{ item.cohortName }} </option>
              </select>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2 pl-0 fs-14 select_section col-md-1_5">
              <select class="form-control br-3 input-bg select_control mb-0" @change="searchParticipantFilterStudies()" v-model="languageFilter">
                <option selected="true" disabled="disabled">Language</option>
                <option value="">None</option>
                <option v-for="(language, index) in studyData.language" :key="index">{{ language.languageName }}</option>
              </select>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2 pl-0 fs-14 select_section col-md-1_5">
              <select class="form-control br-3 input-bg select_control  mb-0" @change="searchParticipantFilterStudies()" v-model="countryFilter">
                <option selected="true" disabled="disabled">Country</option>
                <option value="">None</option>
                <option v-for="(country, index) in studyData.countryList" :key="index">{{ country.countryName }}</option>
              </select>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-5 xs-pl-0 mob-pt15 text-right pr-0" v-bind:class="{ 'col-lg-2': siteDocumentId || composeMessageId, 'col-lg-3': !siteDocumentId || !composeMessageId, 'participant-btn-width': cohortList.length > 1 }">
              <!-- Back to compose button section -->
              <div v-if="canResearchSiteTeamAccess && composeMessageId" class="back-to-compose">
                <button :disabled="composeParticipants.length <= 0" @click="backToComposeMessage" class="btn newBtn br-3 ml-5">Back to Compose Message</button>
              </div>
              <!-- Back to compose button section ends here -->
              <!-- Activate for participant button start -->
              <div v-else-if="(canResearchSiteTeamAccess || canStudyAdminAccess) && siteDocumentId" class="back-to-compose">
                <button :disabled="composeParticipants.length <= 0" @click="activateForParticipant" class="btn newBtn br-3 ml-5">Activate for Participants</button>
              </div>
              <!-- Activate for participant button end -->
              <div v-else>
                <button class="btn newBtn br-3 add_part-btn" v-if="byInvite && participantNotInvited && canInviteParticipants() && !user.readOnly" @click="batchInvite()">Invite all</button>
                <button class="btn newBtn br-3 ml-5 add_part-btn" @click="openAddModal" v-if="byInvite && canInviteParticipants() && !user.readOnly && !participantTransfer && canAddParticipants">Add Participants</button>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 xs-pl-0 mob-pt15 pr-0 col-lg-3">
              <div class="form-group has-feedback">
                <label for="checkWithdrawn" class="Show-Withdrawn-or-Failed-participants">
                  <input id="checkWithdrawn" type="checkbox" class="check-withwrawn" :checked="setWithdrawnOrFailedFilter" v-on:change="changeWithdrawnOrFailedFilter" />
                  Show excluded participants
                  <span class="checkmark"></span>
                </label>
                <span v-if="legacyVal">
                  <i class="fa fa-info-circle help_icon cursor_pointer" v-b-popover.hover="disqualify_text" style="color:#959fa4"></i>
                </span>
                <span v-else>
                  <i class="fa fa-info-circle help_icon cursor_pointer" v-b-popover.hover="discontinue_text"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12 pb-20 pl-0 pr-0">
              <div class="table-column">
                <div class="row pl-15 pr-6">
                  <div v-if="!participantTransfer" class="col col-md-5 p-0 lh-36 fs-17 fw-bold">
                    <span class="color_f16559">{{ totalParticipants }} &nbsp;</span>
                    <span class="color_2d3752">{{ totalParticipants !== null ? "Participants" : "Updating Participant List" }}</span>
                    <span v-if="canResearchSiteTeamAccess && composeMessageId && composeParticipants.length" class="compose-part-sel-text">{{ composeParticipants.length }} participant(s) selected</span>
                    <span v-else-if="(canResearchSiteTeamAccess || canStudyAdminAccess) && siteDocumentId" class="compose-part-sel-text">{{ composeParticipants.length }} participant(s) selected</span>
                  </div>
                  <div v-else class="col col-md-5 p-0 lh-36 fs-17 fw-bold">
                    <span class="color_f16559">{{ totalParticipantsSelected }} &nbsp;</span>
                    <span class="color_2d3752">Participants selected to move</span>
                  </div>
                  <div class="col col-md-7 p-0 show_section text-right d-flex justify-content-end align-center">
                    <a id="compliance-and-completion" class="tooltip-anchor mr-10" tabindex="0">About Compliance and Completion Metrics<img class="ml-8" src="static/img/info-icon.svg" alt="" role="presentation"/></a>
                    <b-tooltip target="compliance-and-completion" custom-class="w-370 compliance-and-completion" triggers="click">
                      <div class="tooltip-desc-container">
                        <h6>View Metrics</h6>
                        <p class="text-desc">Individual completion and compliance metrics are accessible on the Participant’s Profile page.</p>

                        <p class="text-desc mb-0">
                          Study compliance metrics are accessible on the <router-link class="text-anchor" to="../vis/study-completion"><strong>Retention Dashboard</strong></router-link> and <router-link class="text-anchor" to="../vis/study-compliance"><strong>Compliance Dashboard</strong>.</router-link>
                        </p>
                      </div>
                      <hr />
                      <div>
                        <h6>Export Metrics</h6>
                        <p class="text-desc mb-0">
                          A compliance report can be exported from the <router-link class="text-anchor" to="../vis/study-executive"><strong>Study Performance Dashboard</strong></router-link>
                        </p>
                      </div>
                    </b-tooltip>
                    <b-form-select v-model="selectedShowOption" :options="participantListOptions" class="input-bg select_control mb-3 fs-12 w-150" size="sm" @change="showParticipants" />
                  </div>
                </div>
                <div class="wrapper height-500 position-relative">
                  <table class="table pb-20 mb-50">
                    <thead class="table-border fs-12">
                      <tr>
                        <th class="heading-color pl-16" v-if="composeMessageId && canResearchSiteTeamAccess"></th>
                        <th class="heading-color pl-16" v-else-if="siteDocumentId && (canResearchSiteTeamAccess || canStudyAdminAccess)">
                          <input id="selectAll" type="checkbox" class="check-withwrawn" v-model="allParticipantsSelected" v-on:change="activateParticipantsForAll()" />
                        </th>
                        <!-- This is the select all checkbox -->
                        <th class="heading-color w-50 cursor_pointer" v-if="participantTransfer">
                          <input id="selectAll" type="checkbox" class="check-withwrawn" v-model="allParticipantsSelected" v-on:change="selectAllParticipants()" />
                        </th>

                        <th class="heading-color w-170 cursor_pointer pl-16" v-if="canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess || canSiteDataLockAccess || user.readOnly || canCraUBAccess" @click="sortList('email')">
                          <span class="pr-3 position-relative">
                            {{ verificationColumnText }}
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['email'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['email'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color cursor_pointer pl-16" :class="{ 'w-200': canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess, 'w-260': !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) }" @click="sortList('id')">
                          <span class="pr-3 position-relative">
                            THREAD ID
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['id'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['id'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-160 cursor_pointer" @click="sortList('userDefinedParticipantId')">
                          <span class="pr-3 position-relative">
                            Participant ID
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['userDefinedParticipantId'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['userDefinedParticipantId'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-80 cursor_pointer" v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess || canSiteDataLockAccess || user.readOnly)" @click="sortList('userSiteId')">
                          <span class="pr-3 position-relative">
                            Site
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['userSiteId'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['userSiteId'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-119 cursor_pointer pl-0 pr-0" @click="sortList('status')">
                          <span class="pr-3 position-relative">
                            Status
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['status'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['status'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-119 cursor_pointer pl-0 pr-0" @click="sortList('segmentId')" v-if="studyData && studyData.isSegmentSupported">
                          <span class="pr-3 position-relative">
                            Cohort
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['segmentId'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['segmentId'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-110 cursor_pointer pl-0 pr-0" @click="sortList('invitationDate')">
                          <span class="pr-3 position-relative">
                            Invited on
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['invitationDate'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['invitationDate'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-110 cursor_pointer pl-0 pr-0" @click="sortList('source')">
                          <span class="pr-3 position-relative">
                            Source
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['source'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['source'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-110 cursor_pointer pl-0 pr-0" @click="sortList('registrationDate')">
                          <span class="pr-3 position-relative">
                            Registered on
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['registrationDate'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['registrationDate'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-140 cursor_pointer pl-2 pr-0" @click="sortList('latestConsentedOn')">
                          <span class="pr-3 position-relative">
                            Latest Consented on
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['latestConsentedOn'] === true ? 'link-color' : '']"> </i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['latestConsentedOn'] === false ? 'link-color' : '']"> </i>
                            </span>
                          </span>
                        </th>
                        <th class="heading-color w-120 cursor_pointer" @click="sortList('participantStudyDays')">
                          <span class="pr-3 position-relative">
                            Days in study
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['participantStudyDays'] === true ? 'link-color' : '']"></i>
                            </span>
                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['participantStudyDays'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th v-if="studyData.language && studyData.language.length > 1" class="xs-none heading-color w-110 cursor_pointer" @click="sortList('participantLanguage')">
                          <span class="pr-3 position-relative">
                            Language
                            <span class="sortUp">
                              <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags['participantLanguage'] === true ? 'link-color' : '']"></i>
                            </span>

                            <span class="sortDown">
                              <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags['participantLanguage'] === false ? 'link-color' : '']"></i>
                            </span>
                          </span>
                        </th>
                        <th class="xs-none heading-color w-110 cursor_pointer">
                          <span class="pr-3 position-relative">Country</span>
                        </th>
                        <th class="xs-none heading-color w-150" v-if="canInviteParticipants() && !user.readOnly">
                          <span>Action</span>
                        </th>
                        <th class="xs-none heading-color w-150" :class="{ 'new-label-width': item.keyReference == newLabel.keyReference }" v-for="(item, index) in newLabelsList" :key="index">
                          <span class="trigger row" v-if="item.keyReference !== newLabel.keyReference">
                            <span class="col-10 pr-0 position-relative" @click="sortList(item.key, 'custom')">
                              {{ item.value }}
                              <span class="sortUp">
                                <i class="fa fa-angle-up" aria-hidden="true" :class="[headersAscSortFlags[item.key] === true ? 'link-color' : '']"></i>
                              </span>
                              <span class="sortDown">
                                <i class="fa fa-angle-down" aria-hidden="true" :class="[headersAscSortFlags[item.key] === false ? 'link-color' : '']"></i>
                              </span>
                              <span v-if="!canQualityAccess && !canSiteDataLockAccess && !canInterviewerAccess && !canRaterAccess && !user.readOnly" class="col-2 p-0 edit" @click="updateLabel(item)">
                                <i class="fa fa-pencil heading-color"></i>
                              </span>
                            </span>
                          </span>
                          <span v-if="item.keyReference == newLabel.keyReference && !canQualityAccess && !canInterviewerAccess">
                            <div class="row">
                              <div class="col-sm-7 pr-0 pl-0">
                                <input type="text" class="form-control" maxlength="40" required v-model="newLabel.value" placeholder="Enter label name" />
                              </div>
                              <div class="col-sm-5 pr-0 pl-5 pt-2">
                                <span class="cursor_pointer label-icon" @click="createUpdateLabel(newLabel, index)">
                                  <i class="fa fa-check"></i>
                                </span>
                                <span class="cursor_pointer label-icon ml-3" v-if="updateLabelMode" @click="discardChanges()">
                                  <i class="fa fa-times"></i>
                                </span>
                                <span class="cursor_pointer label-icon ml-3" @click="deleteLabel(index, newLabel)">
                                  <i class="fa fa-trash"></i>
                                </span>
                              </div>
                            </div>
                          </span>
                        </th>
                        <th class="xs-none w-2 pr-0 text-right pt-5" v-if="!canQualityAccess && !canSiteDataLockAccess && !canInterviewerAccess && !canRaterAccess && !user.readOnly">
                          <span class="dropdown" id="columnDropDown">
                            <button class="btn bg-white dropdown-toggle" size="sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <img src="static/img/drawer.svg" class="img-mr" />
                            </button>
                            <div class="dropdown-menu fs-12 h-45 pt-3">
                              <div class="dropdown-item cursor_pointer" @click="addNewLabel()">
                                <img src="static/img/expand.svg" alt class="img-size mb-2" />
                                <span class="ml-10 text-color">Add a new label</span>
                              </div>
                            </div>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody v-if="currentParticipantsList && currentParticipantsList.length > 0">
                      <tr v-for="(participant, index) in currentParticipantsList" :key="index">
                        <td class="table-content-color pl-16" v-if="composeMessageId && canResearchSiteTeamAccess">
                          <label class="select-participant">
                            <input :id="participant.id" :value="{ participantId: participant.id, emailId: participant.email }" type="checkbox" v-model="composeParticipants" />
                            <span class></span>
                          </label>
                        </td>
                        <td class="table-content-color pl-16" v-else-if="siteDocumentId && (canResearchSiteTeamAccess || canStudyAdminAccess)">
                          <label class="select-participant">
                            <input :id="participant.id" :value="{ participantId: participant.id, emailId: participant.email }" type="checkbox" v-model="composeParticipants" />
                            <span class></span>
                          </label>
                        </td>
                        <!-- Individual checkboxes to select a participant -->
                        <td class="table-content-color w-20" v-if="participantTransfer">
                          <input type="checkbox" class="check-withwrawn" v-model="selectedParticipantsForTransfer" :value="participant.id" v-on:change="changeSelectedParticipant(participant)" />
                        </td>

                        <td class="table-content-color w-160 pl-16" v-if="canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canSiteDataLockAccess || user.readOnly || canCallCenterAccess || canCraUBAccess">
                          <a class="link" @click="changeState(participant.id)" v-if="participant.mobile && studyData != null && (studyData.verificationMethod == 'phone' || studyData.verificationMethod == 'both') && !participant.showMoreEmail">{{ participant.mobile | national(participant.mobileCountryCode) | trim0 }}</a>
                          <a class="link" @click="changeState(participant.id)" v-if="participant.email.length >= 16 && studyData != null && studyData.verificationMethod != 'phone' && !participant.showMoreEmail">{{ participant.email.slice(0, 12) }}...</a>
                          <a class="link" @click="changeState(participant.id)" v-else-if="participant.email.length < 16 && studyData != null && studyData.verificationMethod != 'phone'">{{ participant.email }}</a>
                          <a v-if="!participant.showMoreEmail && !participant.mobile" class="cursor_pointer table-content-color fs-12" @click="toggleShowMoreEmail(index)">
                            <u>Show</u>
                          </a>
                          <a class="link" @click="changeState(participant.id)" v-if="participant.email.length >= 16 && studyData != null && studyData.verificationMethod != 'phone' && participant.showMoreEmail"> {{ participant.email }}</a>
                          <a v-if="participant.showMoreEmail && !participant.mobile" class="cursor_pointer table-content-color fs-12" @click="toggleShowMoreEmail(index)">
                            <u>Less</u>
                          </a>
                        </td>
                        <td class="table-content-color pl-16" :class="{ 'w-200': canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess, 'w-260': !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) }">
                          <span v-if="(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && !participant.showMore">{{ participant.id.slice(0, 15) }}...</span>
                          <span v-if="(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && participant.showMore">{{ participant.id }}</span>
                          <a class="link" @click="changeState(participant.id)" v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && !participant.showMore" :to="{ name: 'study-participant-details', params: { participantId: participant.id } }"> {{ participant.id.slice(0, 20) }}... </a>
                          <a v-if="!participant.showMore" class="cursor_pointer table-content-color fs-12" @click="toggleShowMore(index)">
                            <u>Show</u>
                          </a>
                          <a class="link" @click="changeState(participant.id)" v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && participant.showMore" :to="{ name: 'study-participant-details', params: { participantId: participant.id } }">
                            {{ participant.id }}
                          </a>
                          <a v-if="participant.showMore" class="cursor_pointer table-content-color fs-12" @click="toggleShowMore(index)">
                            <u>Less</u>
                          </a>
                        </td>
                        <td class="table-content-color w-160">
                          <span v-if="participant.userDefinedParticipantId" v-html="convertArrayStringHtml('', participant.userDefinedParticipantId)"> </span>
                        </td>
                        <td class="table-content-color w-80" v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess || canSiteDataLockAccess || user.readOnly)">
                          {{ participant.userSiteId }}
                        </td>
                        <td
                          class="xs-none w-119 table-content-color pl-0 pr-0"
                          v-bind:class="{
                            color_red: participant.status === getStatuses.WITHDRAWSTUDY || participant.status === getStatuses.DISQUALIFIED || participant.status === getStatuses.WITHDRAWCONSENT,
                            color_yellow: participant.status === getStatuses.INVITED || participant.status === getStatuses.VERIFIED,
                            purple_color: participant.status === getStatuses.PRESCREENED
                          }"
                        >
                          <span class="pr-2" v-if="participant.status !== 'ACTIVEWMODIFICATION'">
                            <span v-if="participant.status === getStatuses.ACTIVEWITHOUTAPP">
                              Active <span class="activeModificationBlock"> <span class="modifiedText">no App</span></span>
                            </span>
                            <span v-else>
                              {{ getStatusText(participant) }}
                              <span class="pl-5" v-b-popover.hover="participant.disqualifyReason" v-if="participant.status === getStatuses.DISQUALIFIED"> <i class="fa fa-info-circle help_icon cursor_pointer"></i></span>

                              <span class="pl-5" v-if="participant.status === getStatuses.SCREENFAILED && participant.hasOwnProperty('screenFailureReasons')">
                                <img src="../../../public/static/img/participant-web-img/screen-failure.svg" data-toggle="modal" data-target="#screenFailureResons" class="screen-failure-popup-icon" v-on:click="getScreenFailureReasons(participant)" />
                              </span>

                              <span class="pl-5" v-if="participant.status === getStatuses.DISCONTINUED">
                                <img src="../../../public/static/img/participant-web-img/screen-failure.svg" data-toggle="modal" data-target="#screenFailureResons" class="screen-failure-popup-icon" v-on:click="getDiscontinuedReasons(participant)" />
                              </span>
                            </span>
                          </span>

                          <span class="pr-10" v-if="participant.status === 'ACTIVEWMODIFICATION'"
                            >Active <span class="activeModificationBlock"> <span class="modifiedText">Modified</span></span>
                          </span>
                        </td>
                        <td v-if="studyData && studyData.isSegmentSupported" class="table-content-color w-80 pl-0 pr-0">
                          {{ getCohortName(participant.segmentId) }}
                        </td>
                        <td class="xs-none table-content-color w-110 pl-0 pr-0">
                          <span v-if="participant.invitationDate && participant.status !== 'ACTIVEWITHOUTAPP'">{{ new Date(participant.invitationDate) | dateFormat("DD MMM YYYY") }}</span>
                        </td>
                        <td class="xs-none table-content-color w-110 pl-0 pr-0">
                          <span v-if="participant.source && participant.status !== 'ACTIVEWITHOUTAPP'">{{ getSourceText(participant) }}</span>
                          <img v-if="participant.source === 'WEB' && participant.status !== 'ACTIVEWITHOUTAPP'" src="../../../public/static/img/participant-web-img/eligibility-questions-popup.svg" data-toggle="modal" data-target="#eligibilityScreenQuestionsAns" class="eligibility-popup-icon" v-on:click="getEligibilityAnswers(participant.id)" />
                        </td>
                        <td class="xs-none table-content-color w-110 pl-0 pr-0">
                          <span v-if="participant.registrationDate">{{ new Date(participant.registrationDate) | dateFormat("DD MMM YYYY") }}</span>
                        </td>
                        <td class="xs-none table-content-color w-110 pl-0 pr-0">
                          <span v-if="participant.latestConsentedOn">{{ new Date(participant.latestConsentedOn) | dateFormat("DD MMM YYYY") }}</span>
                        </td>
                        <td class="xs-none table-content-color w-120">
                          <span v-if="participant.participantStudyDays >= 0 && !(participant.status === getStatuses.INVITED || participant.status === getStatuses.NOTINVITED || participant.status === getStatuses.DISQUALIFIED || participant.status === getStatuses.WITHDRAWSTUDY || participant.status === getStatuses.WITHDRAWCONSENT || participant.status === getStatuses.DISCONTINUED)">{{
                            participant.participantStudyDays
                          }}</span>
                          <span v-if="participant.status === getStatuses.DISQUALIFIED || participant.status === getStatuses.WITHDRAWSTUDY || participant.status === getStatuses.WITHDRAWCONSENT">N/A</span>
                        </td>
                        <td v-if="studyData.language && studyData.language.length > 1" class="xs-none table-content-color w-110">
                          <select :disabled="participant.disabled || canSiteDataLockAccess || user.readOnly" class="select_control change-caret" v-bind:class="{ 'hide-caret': participant.disabled }" v-model="participant.language" v-on:change="setForNonInvitedUser(participant)" name="language">
                            <option :value="undefined" selected="selected" disabled>Select</option>
                            <option :value="lang.language_id" v-for="(lang, index) in participant.linkedLanguages" :key="index" :class="{ 'draft-lang': lang.draft }">{{ lang.display_name }}</option>
                          </select>
                        </td>
                        <td class="xs-none table-content-color w-110">{{ participant.countryName ? participant.countryName : "US" }}</td>
                        <td v-if="canInviteParticipants() && !user.readOnly" class="xs-none table-content-color w-120">
                          <div class="br-30 p-0" v-if="participant.status == getStatuses.NOTINVITED || participant.status == getStatuses.INVITED">
                            <b-btn size="sm" class="fs-12 pl-15 pr-15" variant="outline-primary" v-if="participant.status == getStatuses.NOTINVITED" @click="createUpdateParticipant(participant, true)">Send invite</b-btn>
                            <b-btn size="sm" class="fs-12" variant="outline-primary" v-if="participant.status == getStatuses.INVITED" @click="openInviteModal(participant)">Resend invite</b-btn>
                          </div>
                          <div class="br-30 p-0" v-if="participant.status == getStatuses.REGISTERED" @click="resendVerification(participant)">
                            <b-btn size="sm" class="fs-12" variant="outline-primary">Resend verification</b-btn>
                          </div>
                          <div class="br-30 p-0" data-toggle="modal" data-target="#changeScreeningStatus" v-if="participant.status == getStatuses.PRESCREENED && !canSystemAdminAccess" v-on:click="selectedParticipantForChangeStatus(participant)">
                            <b-btn size="sm" class="fs-12" variant="outline-primary">Change status</b-btn>
                          </div>
                          <div class="br-30 p-0" data-toggle="modal" data-target="#inviteParticipantNow" v-if="participant.status == getStatuses.SCREENPASSED && !canSystemAdminAccess" v-on:click="selectedParticipantForChangeStatus(participant)">
                            <b-btn size="sm" class="fs-12" variant="outline-primary">Change status</b-btn>
                          </div>
                          <div class="br-30 p-0" @click="triggerConsentModal(participant)">
                            <b-btn size="sm" class="fs-12 pr-15 pl-15" v-if="isSiteTeamMember() && studyData.isManualStudyStart && participant.participantStudyStartTrigger.createdBy == null && canAccessTriggerBtn(participant)" variant="outline-primary">Start Study</b-btn>
                          </div>
                        </td>
                        <td class="xs-none w-150" :class="{ 'new-label-width': item.id === newLabelValue.id && participant.id === newLabelValue.participantId }" v-for="(item, index) in newLabelsList" :key="index">
                          <span v-if="item.id">
                            <span v-if="item.id === newLabelValue.id">
                              <span v-if="participant.id === newLabelValue.participantId">
                                <div class="row">
                                  <div class="col-sm-7 pr-0 pl-0">
                                    <!-- <input class="mb-1" maxlength="40" placeholder="Enter label name" v-model="newLabelValue[item.key]"> -->
                                    <input type="text" class="form-control" maxlength="40" required v-model="newLabelValue[item.key]" placeholder="Enter label name" />
                                  </div>
                                  <div v-if="!canQualityAccess && !canSiteDataLockAccess && !canStudyManagerAccess && !canBioStatisticsAccess && !canPharmacovigilanceAccess && !user.readOnly" class="col-sm-5 pr-0 pl-5 pt-2">
                                    <span class="cursor_pointer label-icon" @click="createUpdateLabelValue(newLabelValue, participant)">
                                      <i class="fa fa-check"></i>
                                    </span>
                                    <span class="cursor_pointer label-icon ml-3" @click="discardLabelValueChanges()">
                                      <i class="fa fa-times"></i>
                                    </span>
                                    <span class="cursor_pointer label-icon ml-3" v-if="updateLabelValueMode" @click="deleteLabelValue(index, newLabelValue)">
                                      <i class="fa fa-trash"></i>
                                    </span>
                                  </div>
                                </div>
                              </span>
                              <span v-else>
                                <span v-if="participant[item.key]">{{ participant[item.key] }}</span>
                                <span v-else @click="addLabelValue(participant, item)">CLICK TO ADD</span>
                              </span>
                            </span>
                            <span v-if="item.id !== newLabelValue.id" class="cursor_pointer">
                              <span class="trigger2 row" v-if="participant[item.key]">
                                <span class="col-10 pr-0">{{ participant[item.key] }}</span>
                                <span v-if="!canQualityAccess && !canSiteDataLockAccess && !canInterviewerAccess && !canStudyManagerAccess && !canBioStatisticsAccess && !canPharmacovigilanceAccess && !user.readOnly && !canRaterAccess" class="edit col-2 pr-0" @click="updateLabelValue(item, participant)">
                                  <i class="fa fa-pencil heading-color"></i>
                                </span>
                              </span>
                              <span v-else-if="!canQualityAccess && !canInterviewerAccess && !canStudyManagerAccess && !canBioStatisticsAccess && !canPharmacovigilanceAccess && !canRaterAccess" class="cursor_pointer pl-10" @click="addLabelValue(participant, item)">
                                CLICK TO ADD
                              </span>
                            </span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="allParticipants && allParticipants.length <= 0 && filterTerm === '' && searchTerm === null">
                      <tr>
                        <td :colspan="Object.keys(headersAscSortFlags).length + 1" class="text-center">
                          <div class="row pt-150 text-center">
                            <div class="fs-20"><b>No participants in this study yet</b></div>
                            <div v-if="canInviteParticipants() && !user.readOnly && canAddParticipants && !languageId && !siteDocumentId">
                              <div v-if="byInvite" class="fs-15 line-height pb-15 pt-10">
                                You may start inviting participants or load participants<br />
                                now and send out invitations at a later time.
                              </div>
                              <button class="btn newBtn br-3 fs-15" @click="openAddModal" v-if="byInvite">
                                Start inviting now
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="allParticipants && allParticipants.length <= 0 && (filterTerm !== '' || searchTerm !== null)">
                      <tr>
                        <td :colspan="Object.keys(headersAscSortFlags).length + 1" class="text-center">
                          <div class="row pt-150 text-center">
                            <div class="fs-20">
                              <b>0 participants found</b>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- ADD participant transfer buttons here -->

                  <div class="pb-20 position-absolute bottom-0 transfer-buttons">
                    <div class="" v-if="participantTransfer">
                      <button class="btn fs-12 btn-default btn-cancel-default" @click="cancelTransfer" :disabled="selectedParticipantsForTransfer.length <= 0">Cancel</button>
                      <button class="btn fs-12 btn-primary btn-continue-prim" data-toggle="modal" data-target="#siteIdModal" :disabled="selectedParticipantsForTransfer.length <= 0" @click="doSomethingOnHidden()">Continue</button>
                    </div>
                  </div>

                  <div class="pb-20 pl-15 position-absolute bottom-0" v-if="currentParticipantsList && currentParticipantsList.length">
                    <div class="row display-inline-flex">
                      <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 1 }">
                        <i class="fa fa-angle-left fs-23 pt-3"></i>
                      </div>
                      <div class="pagination pt-3">{{ currentPage }}</div>
                      <div class="pagination2 pt-3">of {{ totalPages }}</div>
                      <div @click="nextPage" class="arrow-icon pt-3 cursor_pointer" :class="{ disabledPagination: currentPage >= totalPages }">
                        <i class="fa fa-angle-right fs-23"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="import-participant-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <button type="button" class="close close-style" data-dismiss="modal"></button>
          <div v-if="showDefaultImport">
            <div class="modal-title pl-20 pr-20 pt-20">Import Participant List</div>
            <div class="modal-body modal-style">
              <p class="mb-80 modal-info">
                If you already have a list of participants ready, you may insert their information into our
                <a class="link-color cursor_pointer" @click="downloadTemplate()">.csv template</a> and upload them into this study’s participant list.
              </p>
            </div>
            <div class="form-group">
              <button class="btn btn-lg btn-block btn-info-blue br-30" @click="importCSV(setImportValue)" :disabled="!setImportValue">Confirm</button>
            </div>
            <div class="footer-close-style" data-dismiss="modal" @click="clearImport()">Close</div>
          </div>
          <div v-if="showImporting">
            <h2 class="color_import text-center">Importing csv file…</h2>
            <div class="file-style">
              <i class="fa fa-file fs-40" aria-hidden="true"></i>
              <br />
              {{ fileName }}
            </div>
            <!--<vue-progress-bar class="progress-position"></vue-progress-bar>-->
            <div class="form-group">
              <p class="text-center">Uploading! Thanks for being patient.</p>
              <!--<div class="footer-close-style" @click="clearImport()" data-dismiss="modal">Cancel upload</div>-->
            </div>
          </div>
          <div v-if="afterImporting">
            <h2 class="color_import text-center" v-if="importPassed">Upload completed</h2>
            <h2 class="color_import text-center" v-if="!importPassed">Upload failed</h2>
            <div class="file-style">
              <i class="fa fa-file fs-40" aria-hidden="true"></i>
              <br />
              <span class="color_import">{{ fileName }}</span>
            </div>
            <div class="form-group">
              <button class="btn btn-lg btn-block btn-info-blue br-30" @click="uploadAnotherCSV()">Upload another csv file</button>
              <button class="btn btn-lg btn-block btn-info-blue br-30" @click="clearImport()" data-dismiss="modal">Done</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="invite-all-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content width-650 p-0">
          <div class="pr-5">
            <button type="button" class="close" data-dismiss="modal" @click="cancelInvite">&times;</button>
          </div>
          <div class="modal-body p-0">
            <div class="row download-modal">
              <h3 class="invite-text" v-if="recordsWithMissingPIDs.length == 0 && recordWithOldFormat.length == 0 && recordsWithDuplicatePIDs.length == 0">
                <b>Invite {{ notInvitedUsers.length }} participants?</b>
              </h3>
            </div>
            <div class="row download-modal pt-6 color_4a4a4a" v-if="recordsWithMissingPIDs.length == 0 && recordWithOldFormat.length == 0">
              <span v-for="(participant, index) in notInvitedUsers" :key="index">
                {{ participant.email }}
                <span v-if="index != notInvitedUsers.length - 1">,</span>
              </span>
            </div>
            <div class="row download-modal pt-6 color_4a4a4a pb-20 information" v-if="studyData && studyData.isParticipantIdRequired && recordsWithMissingPIDs.length > 0">
              <div class="pb-10 modal-heading">The following records were not invited because they are missing the required PID:</div>
              <span v-for="(participant, index) in recordsWithMissingPIDs" :key="index">
                {{ participant.email }}
                <span v-if="index != recordsWithMissingPIDs.length - 1">,</span>
              </span>
            </div>
            <div class="row download-modal pt-6 color_4a4a4a pb-20 mt-20 mb-20 information" v-if="studyData && studyData.participantIdFormatConfigured && studyData.participantIdFormatConfigured.isFormattingChecked && recordWithOldFormat.length > 0">
              <div class="pb-10 modal-heading">The following records have PID not in the set up format:</div>
              <span v-for="(participant, index) in recordWithOldFormat" :key="index">
                {{ participant.email }}
                <span v-if="index != recordWithOldFormat.length - 1">,</span>
              </span>
            </div>
            <div class="row text-center pt-30 pb-20" v-if="recordsWithMissingPIDs.length == 0 && recordWithOldFormat.length == 0">
              <button class="btn no-btn br-2 mr-4" @click="cancelInvite()">No</button>
              <button class="btn yes-btn br-2" @click="inviteAll()">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="batch-import-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content width-650 height-250 pl-24">
          <div class="modal-header border-none">
            <h3 class="modal-title invite-text color_2d3752">
              <b>Batch import</b>
            </h3>
            <button type="button" class="close" data-dismiss="modal" @click="closeImportModal">&times;</button>
          </div>
          <div class="modal-body pl-0 pt-6">
            <div class="row pb-90 color_4a4a4a">
              <b>You are about to import {{ fileLength }} participant(s). Please confirm to continue.</b>
            </div>
            <div class="row text-center">
              <button class="btn cancel-btn br-3 width-100 mr-10" @click="closeImportModal">Cancel</button>
              <button class="btn add-invite-btn br-3 width-100" @click="importCSV(setImportValue)">Import</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="uploading-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content height-250 pl-24">
          <div class="modal-body pt-40 text-center color_2d3752">
            <div class="row">
              <h3>
                <b>Importing participants…</b>
              </h3>
            </div>
            <div class="fs-16">Thanks for your patience</div>
            <div class="pt-20">
              <b-progress :value="value" :max="100" height="6px" variant="success"></b-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="add-error-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog" role="document">
        <!-- Modal content-->
        <div class="modal-content width-650 p-0">
          <div class="pr-5">
            <button type="button" class="close pt-10 pr-10" data-dismiss="modal" @click="closeAddErrorModal">&times;</button>
          </div>
          <div class="modal-body p-0">
            <div class="row download-modal">
              <h3 class="invite-text">
                <b>{{ addErrorTitle }} Participant Error</b>
              </h3>
            </div>
            <div class="row color_e74c3c download-modal pt-10 pb-6" v-if="skippedParticipantsCount > 0">
              <b>{{ skippedParticipantsCount }} participant(s) failed to {{ addErrorTitle.toLowerCase() }}</b>
            </div>
            <div class="bb-e4e8eb" v-if="skippedParticipantsCount > 0"></div>
            <div class="autoScroll">
              <div class="row download-modal pt-6 color_4a4a4a" v-for="(participant, index) in skippedParticipants" :key="index">{{ participant.email || participant.phone }}</div>
            </div>
            <div class="row download-modal pt-30 pb-20">
              <button class="btn add-invite-btn br-3" @click="exportCSV()">Download report</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="download-report-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog" role="document">
        <!-- Modal content-->
        <div class="modal-content width-650 p-0">
          <div class="pr-5">
            <button type="button" class="close pt-10 pr-10" data-dismiss="modal" @click="closeDownloadModal">&times;</button>
          </div>
          <div class="modal-body p-0">
            <div class="row download-modal">
              <h3 class="invite-text">
                <b>Batch import</b>
              </h3>
            </div>
            <div class="row color_e74c3c download-modal pt-10 pb-6" v-if="skippedParticipantsCount > 0">
              <b>{{ skippedParticipantsCount }} participant(s) failed to import</b>
            </div>
            <div class="bb-e4e8eb" v-if="skippedParticipantsCount > 0"></div>
            <div class="autoScroll">
              <div class="row download-modal pt-6 color_4a4a4a" v-for="(participant, index) in skippedParticipants" :key="index">{{ participant.email || participant.phone }}</div>
            </div>
            <div class="row download-modal pt-30 pb-20">
              <button class="btn add-invite-btn br-3" @click="exportCSV()">Download report</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="add-participant-modal" class="modal fade" role="dialog" data-backdrop="static">
      <div class="modal-dialog" :class="[studyData.countryList && studyData.countryList.length == 1 && (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) ? (participant.verificationMethod != 'email' ? 'width-1100' : 'width-850') : 'width-1100']">
        <!-- Modal content-->
        <div class="modal-content pl-24">
          <div>
            <div class="modal-header border-none">
              <h3 class="modal-title invite-text">
                <b>Add Participants</b>
              </h3>
              <button type="button" class="close" @click="closeModal">&times;</button>
            </div>
            <div class="modal-body pl-0 pr-0">
              <div class="row">
                <div class="btn importBtn file-upload mr-4">
                  <input type="file" accept=".csv" class="file-input" id="file_upload" @change="onFileChange($event)" />
                  <span> <img src="static/img/batch-upload.svg" class="pl-4 pr-7 img-mr" />Batch Upload </span>
                </div>
                <div class="btn importBtn lh-15" @click="downloadTemplate()"><img src="static/img/download.svg" class="pl-4 pr-7 img-mr" />Download Batch Upload Template</div>
              </div>
              <div class="autoScrollList participant-form-height">
                <div class="row pb-12 pt-12 d-flex" v-for="(participant, index) in participantsList.filter(participantList => !participantList.added)" :key="participant.dynamicInputID">
                  <!-- TUR-61129 -->
                  <div class="pl-0 col-lg-2 col-sm-2 col-xs-12" v-if="isVerificationMethodFieldVisible">
                    <div class="p-0 col mb-10 text-color font-weight-bold">Verification Method <span aria-hidden="true" class="fa fa-asterisk asterickStyle"></span></div>
                    <div class="show_section verificationMethod">
                      <select
                        class="form-control input-bg select_control"
                        v-model="participant.verificationMethod"
                        v-validate="'required'"
                        :name="`verifyMethod${participant.dynamicInputID}`"
                        :class="{ input: true }"
                        @change="
                          validateParticipants(index);
                          populateCountryOptions(participant);
                        "
                      >
                        <option
                          :value="method.id"
                          v-for="method in [
                            { id: 'email', text: 'Email' },
                            { id: 'phone', text: 'Phone' }
                          ]"
                          :key="method.id"
                          >{{ method.text }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <!-- TUR-61129-->
                  <div class="pl-0 col-sm-3 col-xs-12" v-if="(isBothVerification && participant.verificationMethod === 'email') || isEmailOnlyVerification" :class="[studyData && studyData.countryList && studyData.countryList.length == 1 && (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) ? 'col-lg-4' : 'col-lg-3']">
                    <div class="p-0 col mb-10 text-color font-weight-bold">Participant Email Address <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span></div>
                    <input
                      type="text"
                      v-validate="participant.verificationMethod === 'email' ? 'required|email' : ''"
                      :name="`email${participant.dynamicInputID}`"
                      :class="{ input: true, 'is-danger': participant.emailError || (participant.email && errors.has(`email${participant.dynamicInputID}`)), 'is-success': !errors.has('email') }"
                      class="form-control"
                      v-model="participant.email"
                      placeholder="Enter email address"
                      v-on:keyup="validateParticipants(index)"
                    />
                    <span v-show="participant.email && errors.has(`email${participant.dynamicInputID}`)" class="error-style">Please enter a valid email.</span>
                  </div>
                  <!-- TUR-61129-->
                  <div class="pl-0" v-else :class="[studyData.countryList && studyData.countryList.length == 1 && (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) ? 'col-lg-4 col-sm-3 col-xs-12' : 'col-lg-4 col-sm-3 col-xs-12']">
                    <div class="p-0 col mb-10 text-color font-weight-bold">Participant Verification Phone Number (Mobile) <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span></div>
                    <div v-if="isSiteDetailsLoaded">
                      <vue-tel-input
                        class="mb-0"
                        v-validate="participant.verificationMethod === 'phone' ? 'required' : ''"
                        :wrapperClasses="['vue-tel-macho-style', 'backend']"
                        :name="`mobile${participant.dynamicInputID}`"
                        @onInput="(number, phoneObject) => onInputPhoneNumber(number, phoneObject, participant)"
                        @country-changed="countryChanged($event, participant)"
                        @validate="phoneValidated($event, participant)"
                        @blur="evt => (participant.phoneFieldOnFocus = false)"
                        @focus="evt => (participant.phoneFieldOnFocus = true)"
                        :dropdownOptions="{ showDialCodeInSelection: true }"
                        :preferredCountries="preferredCountries"
                        :defaultCountry="defaultPreferredCountry"
                        mode="national"
                        validCharactersOnly
                        enabledCountryCode
                        placeholder="Enter your phone number"
                        v-model="participant.mobile"
                        v-on:keyup="validateParticipants(index)"
                        v-vue-tel-label.nolabels
                      ></vue-tel-input>
                      <span v-show="!participant.phoneFieldOnFocus && participant.mobile != '' && (!participant.phoneObject || !participant.phoneObject.valid)" class="error-style">Please enter a valid mobile number.</span>
                    </div>
                  </div>
                  <!-- TUR-61129-->
                  <div class="pl-0" v-if="canSystemAdminAccess || userDataAccessType == 'BOTH' || canSupportAccess" :class="[studyData.countryList && studyData.countryList.length == 1 && (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) ? 'col-lg-4 col-sm-3 col-xs-12' : 'col-lg-2 col-sm-3 col-xs-12']">
                    <div class="p-0" :class="[studyData.countryList && studyData.countryList.length == 1 && (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) ? 'col mb-10 text-color font-weight-bold' : 'col mb-10 text-color font-weight-bold']">
                      Site Sub-Type
                      <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span>
                    </div>
                    <div class="show_section siteSubType">
                      <select
                        class="form-control input-bg select_control"
                        v-model="participant.siteSubType"
                        v-validate="'required'"
                        :name="`siteSubType${participant.dynamicInputID}`"
                        @change="
                          validateParticipants(index);
                          populateSiteOptions(participant, $event);
                        "
                      >
                        <option :value="null" disabled>Select</option>
                        <option v-for="(siteSubType, index) in siteSubTypes" :value="siteSubType.value" :key="index">
                          {{ siteSubType.text }}
                        </option>
                      </select>
                    </div>
                    <span v-show="participant.errorSiteSubType && errors.has(`siteSubType${participant.dynamicInputID}`)" class="error-style">
                      Site Sub-type is required.
                    </span>
                  </div>
                  <div v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess)" class="pl-0" :class="[studyData.countryList && studyData.countryList.length == 1 ? 'col-lg-3 col-sm-3 col-xs-12' : 'col-lg-2 col-sm-3 col-xs-12']">
                    <div v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess)" class="p-0" :class="[studyData.countryList && studyData.countryList.length == 1 ? 'col mb-10 text-color font-weight-bold' : 'col mb-10 text-color font-weight-bold']">
                      Site<span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span>
                    </div>
                    <div class="show_section siteId">
                      <select
                        class="form-control input-bg select_control"
                        v-model="participant.siteId"
                        v-validate="'required'"
                        :name="`siteId${participant.dynamicInputID}`"
                        :class="{ input: true, 'is-danger': participant.siteId && errors.has('siteId'), 'is-success': !errors.has('siteId') }"
                        @change="
                          validateParticipants(index);
                          populateCountryOptions(participant);
                        "
                      >
                        <option :value="null" disabled>Select site</option>
                        <option :value="site.id" v-for="site in participant.siteIdOptions" :key="site.id"> {{ site.userSiteId }}</option>
                      </select>
                    </div>
                    <span v-show="participant.errorSite && errors.has(`siteId${participant.dynamicInputID}`)" class="error-style">Please enter a valid siteId.</span>
                  </div>
                  <div class="pl-0 col-lg-3 col-sm-3 col-xs-12':'col-lg-2 col-sm-3 col-xs-12" v-if="studyData && studyData.isSegmentSupported">
                    <div class="p-0 col mb-10 text-color font-weight-bold':'col mb-10 text-color font-weight-bold">Cohort<span aria-hidden="true" class="fa fa-asterisk asterickStyle"></span></div>
                    <div class="show_section siteId">
                      <select class="form-control input-bg select_control" v-model="participant.segmentId">
                        <option :value="null">Pending</option>
                        <option :value="cohort.id" v-for="cohort in studyCohorts" :key="cohort.id">
                          {{ cohort.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div
                    class="pl-0"
                    :class="{
                      'col-lg-2 col-sm-3 col-xs-12': studyData.countryList && studyData.countryList.length > 0 && !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess),
                      'col-lg-3 col-sm-3 col-xs-12': (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && studyData.countryList && studyData.countryList.length > 1,
                      'col-lg-4 col-sm-3 col-xs-12': (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && studyData.countryList && studyData.countryList.length == 1
                    }"
                  >
                    <div
                      class="p-0 col mb-10 text-color font-weight-bold"
                      :class="{
                        'col mb-10 text-color font-weight-bold': studyData.countryList && studyData.countryList.length > 0 && !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess),
                        'col mb-10 text-color font-weight-bold': (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && studyData.countryList && studyData.countryList.length > 1,
                        'col mb-10 text-color font-weight-bold': (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) && studyData.countryList && studyData.countryList.length == 1
                      }"
                    >
                      Participant ID <span v-if="!studyData.isParticipantIdRequired">(Optional)</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="participant.userDefinedParticipantId"
                      placeholder="Enter participant ID"
                      v-on:keyup="validateParticipants(index)"
                      v-if="studyData && studyData.participantIdFormatConfigured && !studyData.participantIdFormatConfigured.isFormattingChecked"
                      :class="{ 'is-danger': studyData && studyData.isParticipantIdRequired && participant.participantConfigurationErrors.length > 0 }"
                    />
                    <template v-if="studyData && studyData.participantIdFormatConfigured && studyData.participantIdFormatConfigured.isFormattingChecked">
                      <div class="otp-input scrollbar participant-list" v-for="(format, i) in participant.formattingArray" :key="i" :class="{ 'not-site-team': !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) }">
                        <otpInputService
                          :options="studyData.participantIdFormatConfigured"
                          v-for="(digit, idx) in format.formatArray"
                          :key="idx"
                          v-model="format.formatArray[idx]"
                          :data-fixedCharacters="fixedCharactersIndex"
                          data-page="participantList"
                          @keyup.native="validateParticipants(index)"
                          :class="{ 'is-danger': participant.participantConfigurationErrors.length > 0 }"
                          :showOldFormat="false"
                        ></otpInputService>
                      </div>
                    </template>
                    <div class="error-style err-position" v-if="participant.participantConfigurationErrors && participant.participantConfigurationErrors.length > 0">
                      <div v-for="(error, index) in participant.participantConfigurationErrors" :key="index">{{ error }}</div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                  <div v-if="studyData.countryList && studyData.countryList.length > 1" class="pl-0 col-lg-2 col-sm-3 col-xs-12">
                    <div v-if="studyData.countryList && studyData.countryList.length > 1" class="p-0 col mb-10 text-color font-weight-bold">Country <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span></div>
                    <div class="show_section country">
                      <select
                        class="form-control input-bg select_control"
                        v-model="participant.countryId"
                        v-validate="'required'"
                        :name="`countryId${participant.dynamicInputID}`"
                        :class="{ input: true, 'is-danger': participant.countryId && errors.has('countryId'), 'is-success': !errors.has('countryId') }"
                        @change="
                          validateParticipants(index);
                          populateLanguageOptions(participant);
                        "
                      >
                        <option :value="null" disabled>Select country</option>
                        <option v-for="c in participant.countrySiteOptions" :value="c.countryId" :key="c.countryId"> {{ c.countryName }}</option>
                      </select>
                    </div>
                    <span v-show="participant.errorCountry && errors.has(`countryId${participant.dynamicInputID}`)" class="error-style">
                      Participant country is required
                    </span>
                  </div>
                  <div class="pl-0" :class="[(studyData.countryList && studyData.countryList.length > 1) || !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) ? 'col-lg-2 col-sm-2 col-xs-12' : 'col-lg-4 col-sm-3 col-xs-12']">
                    <div class="p-0" :class="[(studyData.countryList && studyData.countryList.length > 1) || !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canCallCenterAccess) ? 'col mb-10 text-color font-weight-bold' : 'col mb-10 text-color font-weight-bold']">
                      Invitation Language <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span>
                    </div>
                    <div class="show_section langugage">
                      <select class="form-control input-bg select_control" v-model="participant.language" v-validate="'required'" :name="`language${participant.dynamicInputID}`" :class="{ input: true, 'is-danger': participant.language && errors.has('language'), 'is-success': !errors.has('language') }" @change="validateParticipants(index)" :disabled="canSiteDataLockAccess || user.readOnly">
                        <option :value="null" disabled>Select language</option>
                        <option :value="lang.language_id" v-for="lang in participant.contryWiseLanguages" :key="lang.language_id" :class="{ 'draft-lang': lang.draft }">{{ lang.display_name }}</option>
                      </select>
                    </div>
                    <span v-show="participant.errorLanguage && errors.has(`language${participant.dynamicInputID}`)" class="error-style">Please select language.</span>
                  </div>
                  <div class="cursor_pointer col-lg-1 col-md-1 col-sm-12  col-xs-12 pt-30" v-if="participantsList.length > 1" @click="removeParticipant(index)">
                    <img src="/static/img/collapse.svg" class="pl-4 pr-7 pt-10" />
                  </div>
                </div>
                <div class="row color_1e8fe1 pb-10">
                  <span class="cursor_pointer" @click="addParticipant">Add Another Participant</span>
                </div>
                <div class="invite-text-section" v-if="isEmailOnlyVerification || (isBothVerification && haveAnyEmailInviteParticipant)">
                  <h3 class="modal-title invite-text">
                    <b>Email Invite Method</b>
                  </h3>
                  <p class="text-lGray">Please choose the channel(s) your participants can register through.</p>
                  <label v-if="studyData.ios || studyData.android">
                    <input type="checkbox" v-model="isMobile" />
                    <span class="p-0 pl-8 Participant-email-ad-text">Mobile</span><span v-if="studyData.ios"><i class="fa fa-apple fs-19 text-lGray pl-8" aria-hidden="true"></i></span><span v-if="studyData.android"><i class="fa fa-android text-lGray fs-19 pl-8" aria-hidden="true"></i></span><br /> </label
                  ><br />
                  <label v-if="studyData.web">
                    <input type="checkbox" v-model="isWeb" />
                    <span class="p-0 pl-8 Participant-email-ad-text">Web (URL)</span>
                  </label>
                </div>
                <div class="row color_1e8fe1 pb-10 pt-48">
                  <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle fs-7 ml-0 mr-5"></span>
                  <span style="color:black;font-size:10px">Indicates a Required Field</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class>
                <button class="btn mb-10 add-invite-btn br-3 mr-10" :disabled="errors.any() || disableInvite || hasErrorInParticipantListDoNotInvite" @click="inviteParticipantNew(participantsList, false)">Load Only, Do Not Invite</button>
                <button class="btn mb-10 add-invite-btn br-3" :disabled="errors.any() || disableInvite || hasErrorInParticipantList" @click="inviteParticipantNew(participantsList, true)">Send Invites</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="resend-invite-modal" class="modal fade" role="dialog" data-backdrop="static">
      <div class="resend-invite-modal1 modal-dialog ">
        <div class="modal-content pl-24">
          <div class="modal-header border-none">
            <h3 class="modal-title invite-text">{{ modalText }}</h3>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body invite-text-section p-0" v-if="!isParticipantVerificationPhone">
            <p class="text-lGray">Please choose the channel(s) your participant can register through.</p>
            <label v-if="studyData.ios || studyData.android">
              <input type="checkbox" v-model="isMobile" />
              <span class="p-0 pl-8 Participant-email-ad-text">Mobile</span><span v-if="studyData.ios"><i class="fa fa-apple text-lGray fs-19 pl-8" aria-hidden="true"></i></span><span v-if="studyData.android"><i class="fa fa-android text-lGray fs-19 pl-8" aria-hidden="true"></i></span><br /> </label
            ><br />
            <label v-if="studyData.web">
              <input type="checkbox" v-model="isWeb" />
              <span class="p-0 pl-8 Participant-email-ad-text">Web (URL)</span>
            </label>
          </div>
          <div class="pt-48">
            <button type="button" class="btn mb-10 add-invite-btn br-3 mr-10" data-dismiss="modal" :disabled="!isMobile && !isWeb" @click="createUpdateParticipant(resendInviteParticipant, true)">Resend invite</button>
          </div>
        </div>
      </div>
    </div>
    <ParticipantConsentModal :showConsentModal="consentModalStatus" @cancelButtonClicked="consentModalStatus = false" @triggerDayZeroPopup="triggerDayZeroPopup" />
    <ParticipantTriggerDayZeroModal
      v-if="studyData.isScheduledStart != undefined"
      :triggeredParticipant="triggeredParticipant"
      @resetParticipantDayZeroStatus="resetParticipantDayZeroStatus"
      :showModal="modalStatus"
      :studyId="studyId"
      :piId="user.id"
      @changeParticipantStatusToScreening="onChangeParticipantStatusToScreening"
      @toggleScheduleModal="toggleScheduleModal"
      :isScheduledStart="studyData.isScheduledStart"
    ></ParticipantTriggerDayZeroModal>
    <ScheduleStudyStartModal v-if="triggeredParticipant" :participantId="triggeredParticipant.id" :piId="user.id" :showModal="isScheduleStartModalShown" :participantDetails="triggeredParticipant" @toggleScheduleModal="toggleScheduleModal" @studyStartScheduled="studyStartScheduled"></ScheduleStudyStartModal>
  </div>
</template>

<script>
import moment from "moment";
import Papa from "papaparse";
import FileSaver from "file-saver";
import cloneDeep from "lodash/cloneDeep";
import max from "lodash/max";
import { AclRule } from "vue-acl";
import map from "lodash/map";
import $ from "jquery";
import _ from "lodash";
import sortBy from "lodash/sortBy";
import filter from "lodash/filter";
import { mapGetters } from "vuex";
import { participantStatuses, participantLanguageText, participantSources, participantStatusesText, participantSourcesText, CC, PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, QUALITY, CRA, DM, SITEDATALOCK, STUDY_MANAGER, BSTAT, PHV, RATER, INTERVIEWER, SYSTEM_ADMIN, STUDY_ADMIN, CraUB, SUPPORT } from "@/constants/authRoles";
import ParticipantTriggerDayZeroModal from "@/components/participants/participant-trigger-day-zero-modal";
import ParticipantConsentModal from "@/components/participants/participant-consent-modal";
import LocalStorageService from "../../services/localStorage";
import otpInputService from "../services/otp-input-service";
import ScheduleStudyStartModal from "@/components/participants/schedule-study-start-modal";
import toastr from "toastr";
let dynamicInputID = 0;
export default {
  name: "Participants",
  components: { ParticipantTriggerDayZeroModal, otpInputService, ScheduleStudyStartModal, ParticipantConsentModal },
  props: {
    studyData: Object
  },
  data() {
    return {
      languageFilter: "Language",
      countryFilter: "Country",
      preferredCountries: ["US"],
      isSiteDetailsLoaded: false,
      studyCohorts: [],
      addErrorTitle: "",
      prevRoute: null,
      searchedSite: "",
      currentSiteId: "",
      siteSubTypes: [
        { text: "Live", value: "LIVE" },
        { text: "Test", value: "TEST" }
      ],
      selectedParticipantsForTransfer: [],
      siteSelected: false,
      userReasonForOther: "",
      participantsDataForModal: [],
      allParticipantsSelected: false,
      participantTransfer: false,
      isLoading: false,
      setWithdrawnOrFailedFilter: false,
      selectedLang: "",
      selectedParticipantForChangeStatusValue: {},
      eligibilityScreenQuestionsAnsOfParticipnt: [],
      agreementAcceptedTime: "",
      agreementAcceptedDate: "",
      isSiteTransferReason: false,
      modalStatus: false,
      consentModalStatus: false,
      uploadFileName: "",
      participantsList: [
        {
          dynamicInputID: dynamicInputID,
          email: "",
          verificationMethod: "email",
          mobileCountryCode: null,
          mobile: "",
          siteId: null,
          language: null,
          countryId: null,
          siteSubType: null,
          countrySiteOptions: null,
          phoneFieldOnFocus: false,
          siteIdOptions: null,
          participantConfigurationErrors: [],
          approvedSiteLanguages: {},
          linkedLC: {},
          contryWiseLanguages: [],
          segmentId: null
        }
      ],
      getCallDone: false,
      participant: {},
      mismatchEmail: false,
      byInvite: false,
      enableAddInviteBtn: false,
      importPassed: false,
      participantId: null,
      searchTerm: null,
      setImportValue: null,
      exportData: null,
      allParticipants: {},
      totalParticipants: null,
      totalParticipantsSelected: 0,
      participantNotInvited: false,
      notInvitedUsers: [],
      batchClick: false,
      userDetails: {
        username: "",
        password: null
      },
      downloadStarted: false,
      downloadCompleted: false,
      afterImporting: false,
      showImporting: false,
      showDefaultImport: true,
      filterTerm: "",
      sourcefilter: "",
      cohortFilter: "",
      cohortList: [],
      withdrawnOrFailedFilter: "",
      sortValue: "",
      sortOrder: "",
      customKey: "",
      newLabelsList: [],
      participantStatuses,
      participantStatusesText,
      participantSourcesText,
      participantLanguageText,
      newLabel: {},
      updateLabelMode: false,
      addLabelDisable: false,
      addLabelValueMode: false,
      updateLabelValueMode: false,
      newLabelValue: {},
      labelName: "",
      researchSites: [],
      userDataAccessType: null,
      disableInvite: true,
      value: 10,
      skippedParticipants: [],
      displayLanguage: "",
      skippedParticipantsCount: 0,
      fileLength: 0,
      downloadList: {},
      headersAscSortFlags: {
        id: "",
        email: "",
        mobile: "",
        userDefinedParticipantId: "",
        status: "",
        segmentId: "",
        userSiteId: "",
        participantStudyDays: "",
        participantLanguage: "",
        invitationDate: "",
        source: "",
        registrationDate: "",
        latestConsentedOn: ""
      },
      participants: {},
      selectedParticipants: {},
      currentParticipantsList: {},
      currentPage: 1,
      totalPages: 1,
      selectedShowOption: 15,
      participantListOptions: [
        {
          value: 15,
          text: "Show 15 items"
        },
        {
          value: 50,
          text: "Show 50 items"
        },
        {
          value: 100,
          text: "Show 100 items"
        }
      ],
      siteDetails: null,
      isOldProfileViewEnbaled: false,
      triggeredParticipant: null,
      composeParticipants: [],
      composeMessageId: this.$route.query.composeMessageId,
      siteDocumentId: this.$route.query.siteDocumentId,
      languageId: this.$route.query.languageId,
      activateForMoreParticipants: this.$route.query.activateForMoreParticipants,
      selectedParticipantLength: null,
      feature: [],
      fixedCharactersIndex: [],
      recordsWithMissingPIDs: [],
      recordWithOldFormat: [],
      newSiteTransferReason: "",
      newSite: "",
      listOfSiteTransferReason: [
        {
          name: "Site Closing",
          value: "Site Closing"
        },
        {
          name: "Participant Relocation",
          value: "Participant Relocation"
        },
        {
          name: "Other",
          value: "Other"
        }
      ],
      isScheduleStartModalShown: false,
      studyDetails: {},
      recordsWithDuplicatePIDs: [],
      screenFailureReasons: [],
      failureAndDiscontinuedReasons: [],
      secreenFailureOptions: [
        {
          text: "Failure to meet Inclusion Criteria",
          value: "Failure to meet Inclusion Criteria"
        },
        {
          text: "Failure to meet Exclusion Criteria",
          value: "Failure to meet Exclusion Criteria"
        },
        {
          text: "Participant withdrew consent",
          value: "Participant withdrew consent"
        },
        {
          text: "Other",
          value: "Other"
        }
      ],
      selectedScreenFailure: false,
      otherScreenFailureReasons: "",
      failureReasons: [],
      selectedReason: "",
      showError: false,
      isWeb: false,
      isMobile: false,
      resendInviteParticipant: {},
      selectedStatus: "",
      legacyVal: true,
      disqualify_text: "Participants with the following status are automatically excluded from display on the Participant List: Disqualified, Withdrawn, and Screen Failed. To view all participants with any status value, select the checkbox to show excluded participants.",
      discontinue_text: "Participants with the following status are automatically excluded from display on the Participant List: Discontinued and Screen Failed. To view all participants with any status value, select the checkbox to show excluded participants."
    };
  },
  computed: {
    ...mapGetters(["token", "user"]),
    //TUR-61129
    defaultPreferredCountry() {
      return this.preferredCountries[0];
    },
    verificationColumnText() {
      if (this.studyData != null && this.studyData.verificationMethod != null && this.studyData.verificationMethod === "phone") {
        return "Verification Phone";
      } else if (this.studyData != null && this.studyData.verificationMethod != null && this.studyData.verificationMethod === "both") {
        return "Email / Verification Phone";
      } else {
        return "Email";
      }
    },
    //TUR-61129
    isParticipantVerificationPhone() {
      return !!(this.resendInviteParticipant != null && this.resendInviteParticipant.verificationMethod != null && this.resendInviteParticipant.verificationMethod === "phone");
    },
    modalText() {
      return this.isParticipantVerificationPhone ? "Phone Invite Method" : "Email Invite Method";
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    userToken() {
      return this.token;
    },
    studyId() {
      return this.$route.params.studyId;
    },
    getStatuses() {
      return participantStatuses;
    },
    getSources() {
      return participantSources;
    },
    getStatusesText() {
      return participantStatusesText;
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canDMAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canCRAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canStudyManagerAccess() {
      this.$acl.change(`${STUDY_MANAGER}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canResearchSiteTeamAccess() {
      return this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess || this.canInterviewerAccess || this.canCallCenterAccess;
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    searchedSitesList() {
      if (!this.studyData.sitesInfo) {
        return [];
      }
      if (!this.studyData.sitesInfo.length) {
        return [];
      }
      let sitesInfoArr = this.studyData.sitesInfo.filter(site => site.name.toLowerCase().includes(this.searchedSite.trim().toLowerCase()) || site.userSiteId.toLowerCase().includes(this.searchedSite.trim().toLowerCase()));
      return sitesInfoArr;
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canStudyAdminAccess() {
      this.$acl.change(`${STUDY_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSystemAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canAddParticipants() {
      if (this.canSystemAdminAccess || this.canStudyAdminAccess || this.canStudyManagerAccess || this.canSupportAccess) {
        return true;
      } else if (this.siteDetails && this.siteDetails.canSiteTeamAddParticipant) {
        return true;
      } else {
        return false;
      }
    },
    checkOtherReason() {
      return this.screenFailureReasons.includes("Other");
    },
    checkTextArea() {
      return this.otherScreenFailureReasons.length < 1 ? "input-text-area input-group" : "input-group";
    },
    //TUR-61129
    hasErrorInParticipantList() {
      let emptyItems = this.participantsList.filter(participant => {
        return this.isVerificationFieldInvalid(participant) || participant.siteId == null || participant.language == null || participant.countryId == null || participant.emailError || participant.errorSite || participant.errorlanguage || participant.errorCountry;
      });
      if (emptyItems.length > 0 || (this.haveAnyEmailInviteParticipant && !this.isMobile && !this.isWeb)) {
        return true;
      } else {
        return false;
      }
    },
    hasErrorInParticipantListDoNotInvite() {
      let emptyItems = this.participantsList.filter(participant => {
        return this.isVerificationFieldInvalid(participant) || participant.siteId == null || participant.language == null || participant.countryId == null || participant.emailError || participant.errorSite || participant.errorlanguage || participant.errorCountry;
      });
      if (emptyItems.length === 0) {
        return false;
      } else {
        return true;
      }
    },
    studyVerificationMethod() {
      return this.studyData.verificationMethod ? this.studyData.verificationMethod : "email";
    },
    isEmailOnlyVerification() {
      return this.studyVerificationMethod === "email";
    },
    isPhoneOnlyVerification() {
      return this.studyVerificationMethod === "phone";
    },
    isBothVerification() {
      return this.studyVerificationMethod === "both";
    },
    isVerificationMethodFieldVisible() {
      return this.studyVerificationMethod === "both";
    },
    isEmailInviteVisible() {
      return this.studyVerificationMethod !== "phone";
    },
    haveAnyEmailInviteParticipant() {
      return this.participantsList.reduce((status, participant) => {
        if (status) {
          return true;
        }
        return participant.verificationMethod === "email";
      }, false);
    },
    defaultCountry() {
      return this.siteDetails.countryList.sort((a, b) => a.countryName - b.countryName)[0];
    }
    //TUR-61129
  },
  watch: {
    newSiteTransferReason() {
      this.newSiteTransferReason;
    },
    studyData(newData, oldData) {
      if (this.studyData) {
        this.isWeb = !!this.studyData.web;
        this.isMobile = !!(this.studyData.ios || this.studyData.android);
      }
      if (newData.countryList) {
        this.studyData.countryList = sortBy(newData.countryList, "sortOrder");
      }
      if (newData !== oldData) {
        this.getStudyDetails();
      }
      this.participantsList[0].verificationMethod = this.studyData.verificationMethod === "phone" ? "phone" : "email";
      this.studyCohorts = this.studyData.segments;
    },
    $route(to, from) {
      //The below code looks for the route change, so if a user is on this page and clicks on the participants link
      // provided in the left side bar then the below code will act accordingly.
      if (!to.query.composeMessageId) {
        this.composeMessageId = null;
      } else {
        this.composeMessageId = to.query.composeMessageId;
      }

      if (!to.query.siteDocumentId && from.fullPath.search("siteDocumentId") > 1) {
        this.siteDocumentId = null;
      } else {
        this.siteDocumentId = to.query.siteDocumentId;
      }

      //For reset participant list need to refresh API again without filter data
      if (!to.query.languageId && from.fullPath.search("languageId") > 1) {
        this.languageId = null;
        this.activateForMoreParticipants = null;
        this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
      } else if (to.fullPath.search("siteDocumentId") > 1 && to.fullPath.search("languageId") > 1 && to.fullPath.search("activateForMoreParticipants") > 1) {
        this.languageId = to.query.languageId;
        this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
      }
    },
    composeParticipants: function(val) {
      if (this.composeParticipants.length < this.selectedParticipantLength) {
        this.allParticipantsSelected = false;
      } else if (this.composeParticipants.length == this.selectedParticipantLength) {
        this.allParticipantsSelected = true;
      }
    }
  },
  beforeEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  methods: {
    getCohortName(segmentId) {
      if (!!segmentId == false || !!this.studyData.segments == false || segmentId.toLowerCase() == "pending") {
        return "Pending";
      }
      let pendingCohort = this.studyData.segments.find(field => {
        return field.id == segmentId;
      });
      return pendingCohort ? pendingCohort.name : "Pending";
    },
    emtpyDataForModal() {
      this.participantsDataForModal = [];
      this.newSite = "";
      this.newSiteTransferReason = "";
    },
    checkAllConditions() {
      if ((this.newSiteTransferReason !== "Other" && this.newSiteTransferReason && this.siteSelected) || (this.newSiteTransferReason === "Other" && this.newSiteTransferReason && this.siteSelected && this.userReasonForOther)) {
        return true;
      }
    },
    sendSiteDataToTransfer() {
      let dataOBj = {
        participantIds: this.selectedParticipantsForTransfer,
        userRole: this.user.userRole,
        fromSiteId: this.currentSiteId,
        toSiteId: this.newSite.id,
        reason: this.newSiteTransferReason,
        createdBy: undefined
      };
      if (this.newSiteTransferReason == "Other") {
        dataOBj.reason = this.userReasonForOther;
      }
      this.$api.participantsSiteTransferID(this.studyId, dataOBj).then(
        response => {
          this.participantsDataForModal = [];
          window.$("#demo-2").modal("hide");
          this.$toastr.success("Transfer request has been sent.");
          this.selectedParticipantsForTransfer = [];
          this.allParticipantsSelected = false;
          this.totalParticipantsSelected = 0;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving modifications.");
        }
      );
    },
    getSelectedParticipants() {
      this.selectedParticipantsForTransfer.forEach(selectedParticipantId => {
        this.currentParticipantsList.map(participant => {
          if (participant.id === selectedParticipantId) {
            this.participantsDataForModal.push(participant);
          }
        });
      });
    },
    showSiteTransferReason() {
      this.isSiteTransferReason = !this.isSiteTransferReason;
    },
    truncateUserDefinedParticipantId(givenId) {
      let pId = givenId;
      if (pId && pId.trim()) {
        if (pId.length > 24) {
          pId = pId.substring(0, 15) + "..." + pId.substring(pId.length - 4, pId.length);
        }
      }
      return pId;
    },
    selectSiteToTransfer(site) {
      this.siteSelected = true;
      this.oldsite = this.newSite;
      this.newSite = site;
      if (Object.keys(this.oldsite).length != 0) {
        document.getElementById("selectedSite" + this.oldsite.userSiteId).style.background = "#ffffff";
      }
      let v = document.getElementById("selectedSite" + site.userSiteId);
      v.style.background = "#e3e7e8";
    },
    doSomethingOnHidden() {
      setTimeout(function() {
        $("[id^='selectedSite']").css("background-color", "#ffffff");
      }, 500);
    },
    onSiteTransferReasonClick(IP) {
      this.newSiteTransferReason = IP;
      let v = document.getElementById("showSiteTransferReason");
      v.style.display = "none";
    },
    selectAllParticipants() {
      if (this.allParticipantsSelected) {
        this.selectedParticipantsForTransfer = [];
        for (let participant in this.currentParticipantsList) {
          this.selectedParticipantsForTransfer.push(this.currentParticipantsList[participant].id);
        }
      } else {
        this.selectedParticipantsForTransfer = [];
      }
      this.totalParticipantsSelected = this.selectedParticipantsForTransfer.length;
    },
    changeSelectedParticipant(participant) {
      this.totalParticipantsSelected = this.selectedParticipantsForTransfer.length;
      this.allParticipantsSelected = false;
    },
    cancelTransfer() {
      this.selectedParticipantsForTransfer = [];
      this.totalParticipantsSelected = 0;
      this.allParticipantsSelected = false;
    },
    triggerConsentModal(participant) {
      if (participant.afterRegistrationConsentEnabled && !participant.latestConsentedOn) {
        this.consentModalStatus = true;
      } else {
        this.modalStatus = true;
      }
      this.triggeredParticipant = participant;
    },
    screeningPassed(participantId, email, siteId) {
      if (this.$route.params.studyId) {
        let data = {
          participantId: participantId,
          siteId: siteId,
          screeningFailed: "0",
          screeningPassed: "1",
          invite: "0",
          email: email,
          participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          participantLocalOffset: moment().format("Z"),
          start_date: moment().format("YYYY-MM-DDTHH:mm:ss.SSS"),
          start_date_offset: moment().format("Z"),
          registered_time: moment().format("YYYY-MM-DDTHH:mm:ss.SSS 0000"),
          registration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
          start_date_utc: moment().format("YYYY-MM-DD HH:mm:ss")
        };
        this.$api
          .postUpatedScreeningStatus(this.$route.params.studyId, data)
          .then(response => {
            if (response) {
              this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
              this.$toastr.success("Screening passed status updated successfully.");
            }
          })
          .catch(err => {
            this.$toastr.error("Screening passed status not updated.");
            throw err;
          });
      }
    },
    checkFailedReasonField() {
      if (this.screenFailureReasons.includes("Other") && !this.otherScreenFailureReasons) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    screeningFailed(participantId, email, siteId) {
      if (!this.errors.any()) {
        if (this.$route.params.studyId) {
          let data = {
            screenFailureReasons: {},
            participantId: participantId,
            siteId: siteId,
            screeningFailed: "1",
            screeningPassed: "0",
            invite: "0",
            email: email,
            participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
            participantLocalOffset: moment().format("Z")
          };

          let reasonSelected = this.screenFailureReasons.length > 0 ? this.screenFailureReasons.filter(e => e != "Other") : [];
          if (this.screenFailureReasons.includes("Other")) {
            data.screenFailureReasons.reasons = reasonSelected;
            data.screenFailureReasons.other = this.otherScreenFailureReasons;
          } else {
            data.screenFailureReasons.reasons = reasonSelected;
          }

          window.$("#changeScreeningStatus").modal("hide");
          this.$api
            .postUpatedScreeningStatus(this.$route.params.studyId, data)
            .then(response => {
              if (response) {
                this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
                this.$toastr.success("Screening failed status updated successfully.");
              }
            })
            .catch(err => {
              this.$toastr.error("Screening failed status not updated.");
              throw err;
            });
        }
      }
    },

    invitedParticipant(participantId, email, siteId) {
      if (this.$route.params.studyId) {
        let data = {
          participantId: participantId,
          siteId: siteId,
          screeningFailed: "0",
          screeningPassed: "0",
          invite: "1",
          email: email,
          participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          participantLocalOffset: moment().format("Z")
        };

        this.$api
          .postUpatedScreeningStatus(this.$route.params.studyId, data)
          .then(response => {
            if (response) {
              this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
              this.$toastr.success("Invited successfully.");
            }
          })
          .catch(err => {
            this.$toastr.error("Invitation failed.");
            throw err;
          });
      }
    },

    activeWithoutAppParticipant(participantId, email, siteId) {
      if (this.$route.params.studyId) {
        let data = {
          participantId: participantId,
          siteId: siteId,
          screeningFailed: "0",
          screeningPassed: "0",
          invite: "0",
          email: email,
          participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          participantLocalOffset: moment().format("Z"),
          start_date: moment().format("YYYY-MM-DDTHH:mm:ss.SSS"),
          start_date_offset: moment().format("Z"),
          registered_time: moment().format("YYYY-MM-DDTHH:mm:ss.SSS 0000"),
          registration_date: moment().format("YYYY-MM-DD HH:mm:ss"),
          start_date_utc: moment().format("YYYY-MM-DD HH:mm:ss")
        };
        this.$api
          .postUpatedScreeningStatus(this.$route.params.studyId, data)
          .then(response => {
            if (response) {
              this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
              this.$toastr.success("Participant status updated successfully.");
            }
          })
          .catch(err => {
            this.$toastr.error("Participant status not updated.");
            throw err;
          });
      }
    },

    getEligibilityAnswers(participantId) {
      this.isLoading = true;
      this.eligibilityScreenQuestionsAnsOfParticipnt = [];
      this.agreementAcceptedTime = "";
      this.agreementAcceptedDate = "";
      this.displayLanguage = "";
      this.selectedLang = "";
      this.$api
        .getParticipantWebeligibilityAnswers(this.$route.params.studyId, participantId)
        .then(response => {
          if (response) {
            let utcDate = response.data.data.disclaimer_checked_on_utc;
            const m = moment.utc(moment(utcDate, "YYYY-MM-DD HH:mm:ss").toDate());
            this.agreementAcceptedTime = utcDate ? m.format("h:mma").toUpperCase() : "";
            this.displayLanguage = response.data.data.display_language;
            this.selectedLang = this.getLanguageText(this.displayLanguage);
            this.agreementAcceptedDate = utcDate ? moment.utc(utcDate).format("MMMM DD, YYYY") : "";
            if (response.data.data.eligibilityData) {
              this.eligibilityScreenQuestionsAnsOfParticipnt = response.data.data.eligibilityData;
            }
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          throw err;
        });
    },
    hideModal() {
      setTimeout(() => {
        let ifElementExists = document.getElementById("trigger-day-zero-popup");
        if (ifElementExists == undefined) {
          return;
        }
        if (!ifElementExists.classList.contains("show") && this.modalStatus) {
          this.modalStatus = false;
        }
      }, 100);
    },
    getToggledFeatures() {
      let toggleFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      this.feature = toggleFeatures.filter(toggledFeature => (toggledFeature.featureKey === "ParticipantStatusActiveWModification" && toggledFeature.enabled === true) || (toggledFeature.featureKey === "ParticipantStatusActiveWModificationV2" && toggledFeature.enabled === true));
      toggleFeatures.forEach(feature => {
        if (feature.featureKey === "OLDPROFILEVIEW") {
          this.isOldProfileViewEnbaled = feature.enabled;
        }
      });
    },
    changeState(participantId) {
      if (this.isOldProfileViewEnbaled) {
        this.$router.push({
          name: "study-participant-details",
          params: { participantId: participantId }
        });
      } else {
        this.$router.push({
          name: "participant-profile",
          params: { participantId: participantId }
        });
      }
      this.setFiltersData(participantId);
    },
    // toggle show more flag for the given index participant
    toggleShowMore(index) {
      this.currentParticipantsList[index].showMore = !this.currentParticipantsList[index].showMore;
      this.$forceUpdate();
    },
    toggleShowMoreEmail(index) {
      this.currentParticipantsList[index].showMoreEmail = !this.currentParticipantsList[index].showMoreEmail;
      this.$forceUpdate();
    },
    resetParticipantDayZeroStatus(dayZeroStatus) {
      if (!dayZeroStatus) {
        this.modalStatus = false;
        this.triggeredParticipant = null;
        return;
      }
      let self = this;
      let participant = _.find(self.allParticipants, function(p) {
        return p.id === self.triggeredParticipant.id;
      });
      participant.participantStudyStartTrigger.createdBy = this.user.id;
      this.modalStatus = false;
      this.triggeredParticipant = null;
    },
    studyStartScheduled() {
      //In schedule also we are calling this fun bcoz this is just updating the createdBy to hide the study start button
      this.resetParticipantDayZeroStatus(true);
    },
    isSiteTeamMember() {
      return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canInterviewerAccess || this.canCallCenterAccess;
    },
    canAccessTriggerBtn(participant) {
      if (this.studyData.hasRTSMIntegration) {
        return this.canAccessTriggerBtnIfRTSM(participant);
      }

      return participant.status == this.getStatuses.VERIFIED;
    },
    canAccessTriggerBtnIfRTSM(participant) {
      return (!this.studyData.screeningMilestoneAllowed && participant.status == this.getStatuses.RANDOMIZED) || (this.studyData.screeningMilestoneAllowed && participant.status == this.getStatuses.VERIFIED);
    },
    onChangeParticipantStatusToScreening(participantId) {
      for (const participant of this.allParticipants) {
        if (participant.id == participantId) {
          participant.status = participantStatuses.SCREENING;
          break;
        }
      }
    },
    triggerDayZeroPopup() {
      this.modalStatus = true;
    },
    setForNonInvitedUser(participant) {
      this.notInvitedUsers.map(user => {
        if (user.id == participant.id) {
          user.language = participant.language;
        }
      });
    },
    // change the previous page number and update the participants list
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        if (this.getCallDone) {
          this.currentPage -= 1;
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
        }
      }
    },
    // change the next page number and update the participants list
    nextPage() {
      if (this.currentPage < this.totalPages) {
        if (this.getCallDone) {
          this.currentPage += 1;
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
        }
      }
    },
    // search and filter participants list
    searchParticipantFilterStudies(label) {
      if (this.filterTerm == "WITHDRAWSTUDY") {
        this.withdrawnOrFailedFilter = true;
      } else {
        this.withdrawnOrFailedFilter = false;
      }
      if (!label) {
        this.currentPage = 1;
      }
      if (this.countryFilter == "") {
        this.countryFilter = "Country";
      }
      if (this.languageFilter == "") {
        this.languageFilter = "Language";
      }
      this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
    },
    changeWithdrawnOrFailedFilter() {
      this.currentPage = 1;
      this.setWithdrawnOrFailedFilter = !this.setWithdrawnOrFailedFilter;
      this.withdrawnOrFailedFilter = this.setWithdrawnOrFailedFilter === true ? true : "";
      this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
    },
    //sort participants list
    sortList(sortValue, custom) {
      if (custom) {
        this.sortValue = "customLabel";
        this.customKey = sortValue;
      } else {
        this.sortValue = sortValue;
        this.customKey = "";
      }
      this.resetSortValues(sortValue);
      this.headersAscSortFlags[sortValue] = cloneDeep(!this.headersAscSortFlags[sortValue]);
      if (this.headersAscSortFlags[sortValue]) {
        this.sortOrder = "asc";
      } else {
        this.sortOrder = "desc";
      }
      this.currentPage = 1;
      this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
    },
    resetSortValues(sortValue) {
      Object.keys(this.headersAscSortFlags).forEach(key => {
        if (sortValue !== key) {
          this.headersAscSortFlags[key] = "";
        }
      });
    },
    closeModal() {
      let noParticipants = false;
      this.participantsList.forEach(element => {
        if (element.email !== "" || element.siteId !== null || element.language !== "" || element.userDefinedParticipantId || element.countryId !== "" || element.countryId !== null) {
          noParticipants = true;
        }
      });
      if (noParticipants === false) {
        window.$("#add-participant-modal").modal("hide");
        this.participantsList = [
          {
            email: "",
            siteId: null,
            participantConfigurationErrors: [],
            verificationMethod: this.studyData.verificationMethod === "phone" ? "phone" : "email",
            mobileCountryCode: null,
            mobile: "",
            phoneFieldOnFocus: false
          }
        ];
        this.otpKindInputLogic();
      } else {
        this.$swal({
          title: "Are you sure you want to cancel? Not saved data will be lost.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4a4a4a",
          cancelButtonColor: "#1e8fe1",
          confirmButtonText: "No",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            window.$("#add-participant-modal").modal("hide");
            this.disableInvite = true;
            this.participantsList = [
              {
                dynamicInputID: dynamicInputID,
                email: "",
                siteId: null,
                language: null,
                countryId: null,
                participantConfigurationErrors: [],
                verificationMethod: this.studyData.verificationMethod === "phone" ? "phone" : "email",
                mobileCountryCode: null,
                phoneFieldOnFocus: false,
                mobile: "",
                segmentId: null
              }
            ];
            this.otpKindInputLogic();
          }
        });
      }
    },
    openInviteModal(participant) {
      this.resendInviteParticipant = participant;
      if (!this.isParticipantVerificationPhone && (this.studyData.android || this.studyData.ios) && this.studyData.web) {
        window.$("#resend-invite-modal").modal("show");
      } else {
        this.createUpdateParticipant(participant, true);
      }
    },
    setPreferredCountries() {
      if (this.researchSites && !this.researchSites.length) {
        let tempArr = [];
        tempArr.push(this.researchSites);
        this.researchSites = tempArr;
      }
      let allSitesCountries = this.researchSites && this.researchSites.length > 0 ? this.researchSites.filter(rs => rs.status == "Active").map(s => s.countryList) : null;
      if (allSitesCountries && allSitesCountries.length > 0) {
        let countriesSet = new Set();
        allSitesCountries.forEach(country => {
          country.forEach(countryCode => {
            if (countryCode) {
              countriesSet.add(countryCode.isoCode2);
            }
          });
        });
        this.preferredCountries = Array.from(countriesSet);
        this.preferredCountries.sort();
        this.isSiteDetailsLoaded = true;
        this.$forceUpdate();
      }
    },
    openAddModal() {
      window.$("#add-participant-modal").modal("show");
      if (this.user.userRole !== "Pi" && this.user.userRole !== "SubPi" && this.user.userRole !== "StudyCoordinator" && this.user.userRole !== "HomeHealth" && this.user.userRole !== "CallCenter") {
        this.getSiteDetails();
      } else {
        //Get the site details when any of the site team user logs in.
        if (this.user.siteIds && this.user.siteIds.length > 0 && !this.siteDetails) {
          this.getSiteDetailsFact();
        } else if (this.siteDetails) {
          //this.getSiteDetails()
          //Since the API to get the site details has already been called, no need to call it again
          this.participantsList[0].approvedSiteLanguages = this.siteDetails.approvedSiteLanguages;
          this.participantsList[0].countrySiteOptions = this.siteDetails.countryList;
          this.participantsList[0].linkedLC = this.siteDetails.linkedCountryLanguages;
          //If there is only one country associated to the site then set it as default selected country
          this.setDefaultCountry(this.participantsList[0], this.siteDetails.countryList);
          this.$forceUpdate();
        }
      }
    },
    downloadTemplate() {
      this.downloadStarted = true;
      this.downloadCompleted = true;
      // 61129
      let verificationType = this.studyData.verificationMethod;
      this.$api.downloadTemplateParticipantDataFact(this.studyId, verificationType).then(
        response => {
          this.downloadCompleted = false;
          const donwloadFileName = "import_participant.csv";
          //Work around for IE Browsers
          if (window.navigator.msSaveOrOpenBlob) {
            let blobObject = new Blob([response.body]);
            window.navigator.msSaveBlob(blobObject, donwloadFileName);
          } else {
            const csvContent = `data:text/csv;charset=utf-8,${response.body}`;
            const encodedUri = encodeURI(csvContent);
            const link = window.document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", donwloadFileName);
            window.document.body.appendChild(link); // Required for FF
            link.click();
          }

          this.$toastr.success("Participant template downloaded successfully.");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while downlaoding participants.");
        }
      );
    },
    getStudyDetails() {
      if (this.studyData.onboardingType === "ByInvitation") {
        this.byInvite = true;
      }
      // otp-input-service logic
      this.otpKindInputLogic();
    },
    otpKindInputLogic() {
      if (this.studyData && this.studyData.participantIdFormatConfigured && this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        this.studyData.participantIdFormatConfigured.size = this.studyData.participantIdFormatConfigured.size == 0 ? null : this.studyData.participantIdFormatConfigured.size;
        this.participantsList[0]["formattingArray"] = [{ formatArray: [] }];
        this.participantsList[0].formattingArray[0].formatArray.push(JSON.parse(this.studyData.participantIdFormatConfigured.format));
        this.fixedCharactersIndex = [];
        this.participantsList[0].formattingArray[0].formatArray[0].map((ch, index) => {
          if (ch != "" && ch != null) {
            this.fixedCharactersIndex.push(index);
          }
        });
      }
    },
    selectedParticipantForChangeStatus(participant) {
      this.selectedParticipantForChangeStatusValue = participant;
      this.selectedScreenFailure = false;
      this.showError = false;
      this.screenFailureReasons = [];
      this.otherScreenFailureReasons = "";
    },
    resetSelectedParticipant() {
      this.selectedParticipantForChangeStatusValue = {};
    },

    createUpdateParticipant(participant, invite) {
      let sitestatusCheck = this.studyData.sitesInfo.filter(data => data.id === participant.siteId && (data.status === "Pending" || data.status === "Inactive"));
      if (this.studyData.isParticipantIdRequired && (participant.userDefinedParticipantId == null || participant.userDefinedParticipantId == "")) {
        this.$toastr.error("Participant is missing with required PID.");
        return;
      } else if (this.checkIfParticipantIdFormatHasBeenChanged(participant)) {
        this.$toastr.error("Participant's PID not in the set up format.");
        return;
      } else if (sitestatusCheck.length > 0) {
        this.$toastr.error("Site is not in active status.");
        return;
      }
      let p = this.processTheLanguageKey(participant);
      const participantData = cloneDeep(p);
      participantData.sendInvite = invite;
      const payload = {
        studyId: this.studyId,
        participantId: participantData.id,
        data: participantData,
        isWeb: this.isWeb,
        isMobile: this.isMobile,
        invite: invite
      };
      this.$api.updateParticipantInfoFact(payload).then(
        () => {
          this.$toastr.success(invite ? "Invitation sent." : "Participants updated successfully.");
          this.$router.push({
            name: "study-participants-list",
            params: { studyId: this.studyId }
          });
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating participant.");
        }
      );
    },

    resendVerification(participant) {
      const payload = {
        studyId: this.studyId,
        participantId: participant.id
      };
      this.$api.resendVerificationFact(payload).then(
        () => {
          this.$toastr.success("Verification email sent.");
          this.$router.push({
            name: "study-participants-list",
            params: { studyId: this.studyId }
          });
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating participants.");
        }
      );
    },

    getAllParticipants(selectedShowOption, currentPage, search, filter, sortValue, sortOrder, customKey, sourcefilter, cohortFilter, withdrawnOrFailedFilter) {
      let siteId = this.$route.query.siteId ? this.$route.query.siteId : null;
      let siteDocumentId = this.siteDocumentId ? this.siteDocumentId : null;
      let languageId = this.languageId ? this.languageId : null;
      let activateForMoreParticipants = this.activateForMoreParticipants ? this.activateForMoreParticipants : false;
      let countryIds = "";
      let filteredCountry = this.studyData && this.studyData.countryList ? this.studyData.countryList.filter(c => c.countryName == this.countryFilter) : null;
      let filteredLanguage = this.studyData && this.studyData.language ? this.studyData.language.filter(l => l.languageName == this.languageFilter) : null;
      if (filteredCountry && filteredCountry.length > 0) {
        countryIds = filteredCountry[0].countryId;
      }
      if (filteredLanguage && filteredLanguage.length > 0) {
        languageId = filteredLanguage[0].language_id;
      }
      this.$api.getParticipantsListFact(this.studyId, selectedShowOption, currentPage, search, filter, sortValue, sortOrder, customKey, sourcefilter, cohortFilter, siteDocumentId, languageId, activateForMoreParticipants, this.setWithdrawnOrFailedFilter, false, false, siteId || this.currentSiteId, countryIds).then(
        response => {
          this.allParticipants = response.body.participants;
          this.allParticipants = this.processParticipant(this.allParticipants);
          this.totalParticipants = response.body.totalParticipants;
          this.participantNotInvited = response.body.isParticipantNotInvited;
          this.totalPages = response.body.totalPages;
          this.currentPage = response.body.currentPage;
          this.participants = this.allParticipants;
          this.currentParticipantsList = this.allParticipants;
          this.currentParticipantsList.forEach((element, index) => {
            this.currentParticipantsList[index].email = this.currentParticipantsList[index].verificationMethod && this.currentParticipantsList[index].verificationMethod.toLowerCase() === "phone" ? "" : this.currentParticipantsList[index].email;
            this.currentParticipantsList[index].showMore = false;
          });
          this.getCallDone = true;
          if (this.allParticipantsSelected) {
            this.currentParticipantsList.map(item => {
              let i = this.composeParticipants.findIndex(obj => obj.participantId == item.id);
              if (i == -1) {
                this.selectedParticipantLength += 1;
                this.composeParticipants.push({ emailId: item.email, participantId: item.id });
              }
            });
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participants.");
        }
      );
      this.getCallDone = false;
    },
    // Show the participants list in the table as per the number selected
    showParticipants(selectedShowOption) {
      this.getAllParticipants(selectedShowOption, 1, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.cohortFilter, this.withdrawnOrFailedFilter);
    },

    viewParticipant(participantId) {
      this.$router.push({
        name: "add-edit-participant",
        params: { participantId }
      });
    },

    getSiteDetails() {
      this.$api.getSitesFact(this.studyId).then(
        response => {
          this.researchSites = sortBy(response.body, "createdTime");
          let studiesObj = JSON.parse(window.localStorage.getItem("thread-userObj")).userStudies;
          this.setPreferredCountries();
          if (studiesObj) {
            studiesObj.forEach(test => {
              if (this.studyId == test.studyId) {
                this.userDataAccessType = test.userDataAccessType;
              }
            });
            if (this.userDataAccessType != "BOTH") {
              this.participantsList[0].siteIdOptions = filter(this.researchSites, { siteSubType: this.userDataAccessType });
              this.$forceUpdate();
            }
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites.");
        }
      );
    },

    addParticipant() {
      this.disableInvite = true;
      dynamicInputID++;
      let particpantInviteObj = { dynamicInputID: dynamicInputID, email: "", siteSubType: null, siteId: null, language: null, countryId: null, participantConfigurationErrors: [], segmentId: null };
      //TUR-61129
      particpantInviteObj.verificationMethod = this.studyData.verificationMethod === "both" ? "email" : this.studyData.verificationMethod || "email";
      particpantInviteObj.mobile = "";
      particpantInviteObj.mobileCountryCode = "";
      particpantInviteObj.email = "";
      //TUR-61129
      if (this.siteDetails) {
        particpantInviteObj.countrySiteOptions = this.siteDetails.countryList;
        particpantInviteObj.linkedLC = this.siteDetails.linkedCountryLanguages;
        particpantInviteObj.approvedSiteLanguages = this.siteDetails.approvedSiteLanguages;
        //If there is only one country associated to the site then set it as default selected country
        this.setDefaultCountry(particpantInviteObj, this.siteDetails.countryList);
      }
      if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        particpantInviteObj["formattingArray"] = [{ formatArray: [] }];
        particpantInviteObj.formattingArray[0].formatArray.push(JSON.parse(this.studyData.participantIdFormatConfigured.format));
      }
      if (this.userDataAccessType != "BOTH") {
        particpantInviteObj.siteIdOptions = filter(this.researchSites, { siteSubType: this.userDataAccessType });
      }
      this.participantsList.push(particpantInviteObj);
      // this.populateLanguageOptions(particpantInviteObj)
      this.disableInvite = true;
    },

    removeParticipant(index) {
      this.participantsList.splice(index, 1);
      this.participantsList.forEach((element, i) => {
        this.validateParticipants(i);
      });
    },

    validateParticipants(index) {
      this.disableInvite = true;
      this.participantsList[index].emailError = false;
      if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth" || this.user.userRole === "CallCenter") {
        const siteId = this.user.siteIds[0];
        this.participantsList[index].siteId = siteId;
      }
      if (this.participantsList[index].siteId === null) {
        this.participantsList[index].errorSite = true;
        this.disableInvite = true;
      } else {
        this.participantsList[index].errorSite = false;
      }
      if (!this.studyData.participantIdFormatConfigured.isFormattingChecked && this.studyData.isParticipantIdRequired && (this.participantsList[index].userDefinedParticipantId == null || this.participantsList[index].userDefinedParticipantId == "" || this.participantsList[index].userDefinedParticipantId.trim() == "")) {
        this.participantsList[index].participantConfigurationErrors = ["Participant ID is required."];
        this.participantsList[index].errorParticipant = true;
        this.disableInvite = true;
      } else if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        this.participantsList[index].participantConfigurationErrors = this.checkForParticipantIdConfiguration(this.participantsList[index]);
        this.participantsList[index].errorParticipant = this.participantsList[index].participantConfigurationErrors.length > 0;
        this.disableInvite = this.participantsList[index].participantConfigurationErrors.length > 0;
      } else {
        this.participantsList[index].participantConfigurationErrors = [];
        this.participantsList[index].errorParticipant = false;
      }
      if (this.participantsList[index].language === null) {
        this.participantsList[index].errorlanguage = true;
        this.disableInvite = true;
      } else {
        this.participantsList[index].errorlanguage = false;
      }
      if (this.participantsList[index].countryId == null) {
        this.participantsList[index].errorCountry = true;
        this.disableInvite = true;
      } else {
        this.participantsList[index].errorCountry = false;
      }

      if (this.participantsList[index].siteSubType == null && this.userDataAccessType == "BOTH") {
        this.participantsList[index].errorSiteSubType = true;
        this.disableInvite = true;
      } else {
        this.participantsList[index].errorSiteSubType = false;
      }

      this.$nextTick(function() {
        if (!this.isVerificationFieldInvalid(this.participantsList[index]) && !this.participantsList[index].errorSite && !this.participantsList[index].errorSiteSubType && !this.participantsList[index].errorCountry && !this.participantsList[index].errorlanguage && !this.participantsList[index].errorParticipant) {
          this.disableInvite = false;
        }
      });

      this.$forceUpdate();
    },

    inviteParticipant(list, invite) {
      const self = this;
      let totalCount = 0;
      let successCount = 0;
      const addedList = filter(list, o => !o.added);
      addedList.forEach(async participant => {
        const data = participant;
        data.sendInvite = invite;
        try {
          await self.$api.addNewParticipantInfoFact(self.studyId, data);
          data.added = true;
          self.$forceUpdate();
          self.validate(list);
          totalCount += 1;
          successCount += 1;
          self.showMessage(successCount, invite, totalCount, addedList.length);
        } catch (error) {
          data.added = false;
          self.validate(list);
          data.emailError = true;
          self.$forceUpdate();
          totalCount += 1;
          self.showMessage(successCount, invite, totalCount, addedList.length);
          self.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding participants.");
        }
      });
    },
    processTheLanguageKey(list) {
      if (Array.isArray(list)) {
        list.map(participant => {
          participant.languageKey = participant.language;
          delete participant.language;
          delete participant.countrySiteOptions;
        });
      } else {
        let participantObj = { ...list };
        participantObj.languageKey = participantObj.language;
        delete participantObj.language;
        delete participantObj.countrySiteOptions;
        return participantObj;
      }
    },
    checkForParticipantIdConfiguration(list) {
      let errors = [];
      let participantIdList = _.cloneDeep(list);
      // remove fixed characters from the string.
      let characters = participantIdList.formattingArray[0].formatArray[0].filter((ch, index) => {
        if (this.fixedCharactersIndex.indexOf(index) == -1 && ch != null) {
          return ch;
        }
      });
      // check for pid is required or not, pid length,
      if (characters.length == 0 && this.studyData.isParticipantIdRequired) {
        errors.push("Participant ID is required.");
      } else if (characters.length != 0 && characters.length != this.studyData.participantIdFormatConfigured.size - this.fixedCharactersIndex.length) {
        errors.push("Incorrect PID length.");
      }

      if (errors.length > 0) {
        return errors;
      }

      let PID = characters.join("");
      if (this.studyData.participantIdFormatConfigured.isDisallowLetters && /[a-zA-Z]/g.test(PID)) {
        errors.push("Letters are not allowed.");
      } else if (this.studyData.participantIdFormatConfigured.isDisallowNumbers && /[0-9]/g.test(PID)) {
        errors.push("Numbers are not allowed");
      } else if (this.studyData.participantIdFormatConfigured.isDisallowSpecialCharacters && /[[\\\];=!@#$%^&*(),'_.?":{}|<>+~/`-]/g.test(PID)) {
        errors.push("Special characters are not allowed");
      }
      return errors;
    },
    processTheParticipantId(list) {
      if (list.length == 0) {
        return;
      }
      list.map((participant, i) => {
        // remove fixed characters from the string.
        let characters = participant.formattingArray[0].formatArray[0];
        if (this.fixedCharactersIndex.length > 0) {
          characters = participant.formattingArray[0].formatArray[0].filter((ch, index) => {
            if (this.fixedCharactersIndex.indexOf(index) > -1) {
              return ch;
            }
          });
        }
        participant.userDefinedParticipantId = characters.length == 0 ? null : participant.formattingArray[0].formatArray[0].join("");
      });
    },
    inviteParticipantNew(list1, invite) {
      let list = JSON.parse(JSON.stringify(list1)).map(item => {
        if (item.verificationMethod == "phone") {
          item.mobileCountryCode = "+" + item.phoneObject.country.dialCode;
          item.mobile = item.phoneObject.number.significant;
          item.mobileIso3 = item.phoneObject.country.iso2;
          delete item.phoneObject;
          delete item.phoneFieldOnFocus;
          delete item.email;
        } else {
          delete item.mobileCountryCode;
          delete item.mobile;
        }
        return item;
      });
      this.addErrorTitle = "";
      //reset invite participant dialog form reset start
      let resetForm = () => {
        this.filterTerm = "";
        this.searchTerm = "";
        this.sourcefilter = "";
        this.cohortFilter = "";
        this.withdrawnOrFailedFilter = "";
        this.resetSortValues("");
        this.participantsList = [
          {
            email: "",
            mobile: "",
            mobileCountryCode: "",
            verificationMethod: this.studyData.verificationMethod === "phone" ? "phone" : "email",
            siteId: null,
            language: null,
            countryId: null,
            countrySiteOptions: null,
            phoneFieldOnFocus: false,
            participantConfigurationErrors: [],
            segmentId: null
          }
        ];
      };
      //reset invite participant dialog form reset ends

      //reset invite participant success handler starts
      let resolve = response => {
        this.downloadList = response.body;
        this.skippedParticipants = response.body.skippedParticipants;
        this.skippedParticipantsCount = response.body.skippedParticipantsCount;
        window.$("#add-participant-modal").modal("hide");
        if (this.skippedParticipantsCount > 0) {
          this.addErrorTitle = invite ? "Invite" : "Load";
          window.$("#add-error-modal").modal("show");
          window.$("#add-error-modal").on("shown.bs.modal", function(e) {
            $("body").addClass("modal-open");
          });
        }
        if (response.body.importParticipantsCount > 0) {
          if (invite) {
            this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) invited.`);
          } else {
            this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) loaded.`);
          }
        }
        this.getAllParticipants(this.selectedShowOption, this.currentPage);
        resetForm();
        this.otpKindInputLogic();
      };
      //reset invite participant success handler ends

      //reset invite participant error handler starts
      let error = error => {
        resetForm();
        window.$("#add-participant-modal").modal("hide");
        this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding participants.");
      };
      //reset invite participant error handler ends
      if (this.studyDetails.allowDuplicatePid == true) {
        this.$swal({
          title: "This Participant ID is currently in use. If you choose to proceed, this PID will be assigned to more than one participant. Would you like to proceed?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.disableInvite = true;
            this.processTheLanguageKey(list);
            if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
              this.processTheParticipantId(list);
            }
            this.$api.addParticipantListFact(this.studyId, invite, list, this.isWeb, this.isMobile).then(resolve, error);
          }
        });
      } else {
        this.disableInvite = true;
        this.processTheLanguageKey(list);
        if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
          this.processTheParticipantId(list);
        }
        this.$api.addParticipantListFact(this.studyId, invite, list, this.isWeb, this.isMobile).then(resolve, error);
      }
    },
    getStudyDetailsFact(flag) {
      this.notInvitedUsers = [];
      this.$api.getNotInvitedParticipantsFact(this.studyId).then(
        response => {
          response.body.forEach(part => {
            this.notInvitedUsers.push(part);
          });
          if (flag) {
            this.getUniqueNotInvitedUser();
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study detail.");
        }
      );
    },
    showMessage(successCount, invite, count, length) {
      if (count === length) {
        if (invite) {
          this.$toastr.success(`${successCount} Participant(s) invited.`);
        } else {
          this.$toastr.success(`${successCount} Participant(s) imported.`);
        }
      }
    },
    validate(list) {
      const addedList = filter(list, o => o.added);
      if (addedList.length === list.length) {
        this.getAllParticipants(this.selectedShowOption, this.currentPage);
        this.filterTerm = "";
        this.searchTerm = "";
        this.sourcefilter = "";
        this.cohortFilter = "";
        this.withdrawnOrFailedFilter = "";
        this.resetSortValues("");
        window.$("#add-participant-modal").modal("hide");
        this.participantsList = [
          {
            email: "",
            siteId: null,
            language: null,
            countryId: null,
            countrySiteOptions: null,
            participantConfigurationErrors: [],
            verificationMethod: this.studyData.verificationMethod === "phone" ? "phone" : "email",
            mobileCountryCode: null,
            mobile: "",
            phoneFieldOnFocus: false,
            segmentId: null
          }
        ];
        this.otpKindInputLogic();
      }
    },

    goToEditParticipantProfile() {
      this.editable = false;
    },

    closeImportModal() {
      window.$("#batch-import-modal").modal("hide");
      this.setImportValue = null;
      window.$('#file_upload[type="file"]').val(null);
    },
    closeAddErrorModal() {
      window.$("#add-error-modal").modal("hide");
      window.$("#add-error-modal").on("hidden.bs.modal", function(e) {
        $("body").removeClass("modal-open");
      });
    },
    closeDownloadModal() {
      window.$("#download-report-modal").modal("hide");
      window.$("#download-report-modal").on("hidden.bs.modal", function(e) {
        $("body").removeClass("modal-open");
      });
    },
    onFileChange() {
      let self = this;
      const fd = new FormData();
      const input = window.document.getElementById("file_upload");
      fd.append("file", input.files[0]);
      fd.append("sendInvite", false);
      this.setImportValue = fd;
      this.uploadFileName = input.files[0].name;
      Papa.parse(input.files[0], {
        complete: results => {
          let resultsArrayLength = 6;
          if (self.isPhoneOnlyVerification) {
            resultsArrayLength = 7;
          } else if (self.isBothVerification) {
            resultsArrayLength = 9;
          }
          const data = filter(results.data, o => o.length === resultsArrayLength);
          self.fileLength = data.length - 1;
          window.$("#add-participant-modal").modal("hide");
          if (data.length - 1 > 0 && self.checkVerificationMethod(data, self.studyVerificationMethod)) {
            window.$("#batch-import-modal").modal("show");
          } else {
            self.$toastr.error("Uploaded file is not in the expected format. Please use the batch upload template.");
          }
        }
      });
      this.$forceUpdate();
      window.document.getElementById("file_upload").value = null;
    },
    checkVerificationMethod(data, verificationType) {
      if (this.isEmailOnlyVerification) {
        if (data[0][0] === "Participant Email Address" && data[0][1] === "Site ID" && data[0][2] === "Participant ID" && data[0][3] === "Language" && data[0][4] === "Country" && data[0][5] === "Cohort") {
          return true;
        }
        return false;
      } else if (this.isPhoneOnlyVerification) {
        if (data[0][0] === "Country Code for Participant Verification Phone Number (Mobile)" && data[0][1] === "Participant Verification Phone Number (Mobile)" && data[0][2] === "Site ID" && data[0][3] === "Participant ID" && data[0][4] === "Language" && data[0][5] === "Country" && data[0][6] === "Cohort") {
          return true;
        }
        return false;
      } else if (this.isBothVerification) {
        if (data[0][0] === "Verification Method" && data[0][1] === "Participant Email Address" && data[0][2] === "Country Code for Participant Verification Phone Number (Mobile)" && data[0][3] === "Participant Verification Phone Number (Mobile)" && data[0][4] === "Site ID" && data[0][5] === "Participant ID" && data[0][6] === "Language" && data[0][7] === "Country" && data[0][8] === "Cohort") {
          return true;
        }
        return false;
      }
    },
    uploadAnotherCSV() {
      this.showDefaultImport = true;
      this.afterImporting = false;
      this.setImportValue = null;
    },
    importCSV(setImportValue) {
      this.fileName = this.uploadFileName;
      this.showDefaultImport = false;
      this.showImporting = true;
      this.closeImportModal();
      window.$("#uploading-modal").modal("show");
      this.value = 0;
      window.setInterval(() => {
        this.value = this.value + 10;
      }, 100);
      this.$forceUpdate();
      this.$api.importParticipantDataFact(this.studyId, setImportValue).then(
        response => {
          this.importPassed = true;
          this.showImporting = false;
          this.afterImporting = true;
          this.skippedParticipants = response.body.skippedParticipants;
          this.skippedParticipantsCount = response.body.skippedParticipantsCount;
          if (response.body.importParticipantsCount > 0) {
            this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) loaded.`);
          }
          this.downloadList = response.body;
          this.getAllParticipants(this.selectedShowOption, this.currentPage);
          this.searchTerm = "";
          this.filterTerm = "";
          this.sourcefilter = "";
          this.cohortFilter = "";
          this.withdrawnOrFailedFilter = "";
          this.resetSortValues("");
          this.setImportValue = null;
          this.value = 100;
          window.clearInterval();
          window.$("#uploading-modal").modal("hide");
          window.$("#download-report-modal").modal("show");
          window.$("#download-report-modal").on("shown.bs.modal", function(e) {
            $("body").addClass("modal-open");
          });
          this.$forceUpdate();
          this.participantsList = [
            {
              dynamicInputID: dynamicInputID,
              email: "",
              siteId: null,
              language: null,
              countryId: null,
              participantConfigurationErrors: [],
              verificationMethod: this.studyData.verificationMethod === "phone" ? "phone" : "email",
              mobileCountryCode: null,
              mobile: "",
              phoneFieldOnFocus: false,
              segmentId: null
            }
          ];
          this.otpKindInputLogic();
        },
        error => {
          this.importPassed = false;
          window.clearInterval();
          window.$("#uploading-modal").modal("hide");
          window.$("#download-report-modal").modal("show");
          window.$("#download-report-modal").on("shown.bs.modal", function(e) {
            $("body").addClass("modal-open");
          });
          this.$forceUpdate();
          this.showImporting = false;
          this.afterImporting = true;
          this.setImportValue = null;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading participants csv.");
        }
      );
    },
    getDateStamp() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const year = now.getFullYear();
      const hours = now.getHours();
      const mins = `0${now.getMinutes()}`.slice(-2);
      return `${month}-${day}-${year}-${hours}-${mins}`;
    },
    download() {
      this.downloadStarted = true;
    },
    downloadAgain() {
      this.downloadStarted = false;
      this.userDetails.password = null;
      this.errors.clear();
    },
    exportCSV() {
      const fileName = `participants_${this.getDateStamp()}.csv`;
      const ua = navigator.userAgent.toLowerCase();
      let type = "";
      if (ua.indexOf("safari") !== -1) {
        if (!(ua.indexOf("chrome") > -1 || ua.indexOf("crios") > -1)) {
          type = "attachment/csv;charset=utf-8";
        }
      }
      type = "text/csv;charset=utf-8";
      const list = [];
      if (this.studyData.verificationMethod == "both") {
        this.downloadList.skippedParticipants.forEach(element => {
          list.push({
            "Verification Method": element.verificationMethod,
            "Participant Email Address": element.email,
            "Country Code for Participant Verification Phone Number (Mobile)": element.mobileCountryCode,
            "Participant Verification Phone Number (Mobile)": element.phone,
            "Site ID": element.siteId,
            "Participant ID": element.participantId,
            Status: "failed",
            "Failure reason": element.reason
          });
        });
        this.downloadList.importParticipants.forEach(element => {
          list.push({
            "Verification Method": element.verificationMethod,
            "Participant Email Address": element.email,
            "Country Code for Participant Verification Phone Number (Mobile)": element.mobileCountryCode,
            "Participant Verification Phone Number (Mobile)": element.phone,
            "Site ID": element.siteId,
            "Participant ID": element.participantId,
            Status: "imported",
            "Failure reason": element.reason
          });
        });
      } else if (this.studyData.verificationMethod == "phone") {
        this.downloadList.skippedParticipants.forEach(element => {
          list.push({
            "Country Code for Participant Verification Phone Number (Mobile)": element.mobileCountryCode,
            "Participant Verification Phone Number (Mobile)": element.phone,
            "Site ID": element.siteId,
            "Participant ID": element.participantId,
            Status: "failed",
            "Failure reason": element.reason
          });
        });
        this.downloadList.importParticipants.forEach(element => {
          list.push({
            "Country Code for Participant Verification Phone Number (Mobile)": element.mobileCountryCode,
            "Participant Verification Phone Number (Mobile)": element.phone,
            "Site ID": element.siteId,
            "Participant ID": element.participantId,
            Status: "imported",
            "Failure reason": element.reason
          });
        });
      } else {
        this.downloadList.skippedParticipants.forEach(element => {
          list.push({
            "Participant Email Address": element.email,
            "Site ID": element.siteId,
            "Participant ID": element.participantId,
            Status: "failed",
            "Failure reason": element.reason
          });
        });
        this.downloadList.importParticipants.forEach(element => {
          list.push({
            "Participant Email Address": element.email,
            "Site ID": element.siteId,
            "Participant ID": element.participantId,
            Status: "imported",
            "Failure reason": element.reason
          });
        });
      }
      const csv = Papa.unparse(list);
      const blob = new Blob([csv], { type });
      FileSaver.saveAs(blob, fileName);
    },
    batchInvite() {
      this.getNotInvitedUserList(true);
      this.recordsWithMissingPIDs = [];
      this.recordsWithDuplicatePIDs = [];
      this.recordWithOldFormat = [];
      window.$("#invite-all-modal").modal("show");
    },
    inviteAll() {
      let batchInviteList = [];
      this.recordsWithMissingPIDs = [];
      this.recordsWithDuplicatePIDs = [];
      this.recordWithOldFormat = [];
      let self = this;
      this.notInvitedUsers.forEach(user => {
        let currentlanguage;
        self.currentParticipantsList.forEach(element => {
          if (element.id == user.id) {
            currentlanguage = element.language;
          }
        });
        const par = {};
        par.participantId = user.id;
        par.languageKey = currentlanguage || user.language;
        if (this.studyData.isParticipantIdRequired && (user.userDefinedParticipantId == undefined || user.userDefinedParticipantId == "")) {
          this.recordsWithMissingPIDs.push(user);
        } else if (this.checkIfParticipantIdFormatHasBeenChanged(user)) {
          this.recordWithOldFormat.push(user);
        } else {
          batchInviteList.push(par);
        }
      });
      if (batchInviteList.length == 0) {
        if (this.recordsWithMissingPIDs.length > 0 || this.recordWithOldFormat.length > 0) {
          window.$("#invite-all-modal").modal("show");
        } else {
          window.$("#invite-all-modal").modal("hide");
        }
        return;
      }
      this.$api.batchInviteInfoFact(this.studyId, batchInviteList).then(
        response => {
          const keys = Object.keys(response.body);
          const invitedLength = batchInviteList.length - keys.length;
          if (invitedLength > 0) {
            this.$toastr.success(`${invitedLength} participant(s) invited.`);
            if (this.recordsWithMissingPIDs.length > 0 || this.recordWithOldFormat.length > 0) {
              window.$("#invite-all-modal").modal("show");
            } else {
              window.$("#invite-all-modal").modal("hide");
            }
          } else {
            let results = JSON.parse(JSON.stringify(response.body));
            let count = 0;
            this.recordsWithDuplicatePIDs = [];

            for (let index = 0; index < keys.length; index++) {
              let element = results[keys[index]];
              if (element === "The following records have duplicate PID.") {
                let objPar = {};
                objPar.email = keys[index];
                this.recordsWithDuplicatePIDs.push(objPar);
                count++;
              }
            }

            if (count > 0) {
              window.$("#invite-all-modal").modal("show");
            } else {
              window.$("#invite-all-modal").modal("hide");
            }

            this.$toastr.error(`${keys.length} participant(s) invitation failed.`);
          }
          this.getAllParticipants(this.selectedShowOption, this.currentPage);
          this.searchTerm = "";
          this.filterTerm = "";
          this.sourcefilter = "";
          this.cohortFilter = "";
          this.withdrawnOrFailedFilter = "";
          this.resetSortValues("");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participants.");
        }
      );
    },
    getUniqueNotInvitedUser() {
      const result = [];
      const map = new Map();
      for (const item of this.notInvitedUsers) {
        if (!map.has(item.id)) {
          map.set(item.id, true); // set any value to Map
          result.push(item);
        }
      }
      this.notInvitedUsers = result;
    },
    cancelInvite() {
      window.$("#invite-all-modal").modal("hide");
      this.recordsWithMissingPIDs = [];
      this.recordWithOldFormat = [];
    },
    clearImport() {
      this.showDefaultImport = true;
      window.$("#import-participant-modal").modal("hide");
      this.afterImporting = false;
      this.showImporting = false;
    },
    addNewLabel() {
      let maxIndex = Number(max(map(this.newLabelsList, "keyReference")));
      maxIndex = maxIndex || 1;
      if (this.newLabelsList.length > 0) {
        if (this.newLabelsList[this.newLabelsList.length - 1].id) {
          this.newLabel = { keyReference: maxIndex + 1, key: "", value: "" };
          this.newLabelsList.push(this.newLabel);
        } else {
          this.$toastr.error("Custom label value should not be empty.");
        }
      } else {
        this.newLabel = { keyReference: maxIndex + 1, key: "", value: "" };
        this.newLabelsList.push(this.newLabel);
      }
      this.addLabelDisable = true;
      this.updateLabelMode = false;
    },
    getCustomLabels() {
      this.$api.getLabelsFact(this.studyId).then(
        response => {
          this.newLabelsList = sortBy(response.body, "keyReference");
          response.body.forEach(element => {
            this.headersAscSortFlags[element.key] = "";
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
        }
      );
    },
    createUpdateLabelCallback(index, response) {
      this.newLabelsList.splice(index, 1, response);
      this.newLabel = {};
      this.addLabelDisable = false;
      this.updateLabelMode = false;
    },
    createUpdateLabel(item, index) {
      if (item.keyReference) {
        if (this.updateLabelMode) {
          this.$api.updateNewLabelFact(this.studyId, item.id, item).then(
            response => {
              this.createUpdateLabelCallback(index, response.body);
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
            }
          );
        } else {
          this.$api.addNewLabelFact(this.studyId, item).then(
            response => {
              this.headersAscSortFlags[item.key] = "";
              this.createUpdateLabelCallback(index, response.body);
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
            }
          );
        }
      }
    },
    updateLabel(item) {
      this.newLabel = cloneDeep(item);
      this.addLabelDisable = true;
      this.updateLabelMode = true;
    },
    discardChanges() {
      this.newLabel = {};
      this.addLabelDisable = false;
      this.updateLabelMode = false;
    },
    deleteLabelCallback(index) {
      this.newLabelsList.splice(index, 1);
      this.newLabel = {};
      this.addLabelDisable = false;
      this.updateLabelMode = false;
    },
    deleteLabel(index, item) {
      this.$swal({
        title: "Are you sure you want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          if (item.keyReference) {
            if (this.updateLabelMode) {
              this.$api.deleteNewLabelFact(this.studyId, item.id).then(
                () => {
                  this.deleteLabelCallback(index);
                  this.getAllParticipants(this.selectedShowOption, this.currentPage);
                  this.searchTerm = "";
                  this.filterTerm = "";
                  this.sourcefilter = "";
                  this.cohortFilter = "";
                  this.withdrawnOrFailedFilter = "";
                  this.resetSortValues("");
                },
                error => {
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
                }
              );
            } else {
              this.deleteLabelCallback(index);
            }
          }
        }
      });
    },
    addLabelValue(participant, item) {
      this.newLabelValue = cloneDeep(item);
      this.newLabelValue[this.newLabelValue.key] = "";
      this.newLabelValue.participantId = participant.id;
      this.newLabelValue[item.key] = "";
    },
    createUpdateLabelValue(newLabelValue, participant) {
      const newLabel = cloneDeep(newLabelValue);
      this.updateLabelValueMode = false;
      if (newLabelValue.key !== "") {
        newLabel.email = participant.email;
        newLabel.id = newLabel.participantId;
        newLabel.sendInvite = false;
        const pData = {
          studyId: this.studyId,
          participantId: participant.id,
          data: newLabel
        };
        this.$api.addNewLabelValueFact(pData).then(
          () => {
            this.searchParticipantFilterStudies("label");
            this.newLabelValue = {};
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
          }
        );
      } else {
        this.$toastr.error("Please enter a value for the label.");
      }
    },
    discardLabelValueChanges() {
      this.newLabelValue = {};
      this.updateLabelValueMode = false;
    },
    updateLabelValue(newLabelValue, participant) {
      const newLabel = cloneDeep(newLabelValue);
      const value = participant[newLabel.key];
      newLabel[newLabel.key] = value;
      newLabel.participantId = participant.id;
      this.newLabelValue = newLabel;
    },
    getStatusText(participant) {
      return this.participantStatusesText[participant.status];
    },
    getSourceText(participant) {
      return this.participantSourcesText[participant.source];
    },
    getLanguageText(language) {
      return this.participantLanguageText[language];
    },
    canInviteParticipants() {
      let rolesNotInviteParticipants = [CRA, DM, QUALITY, SITEDATALOCK, BSTAT, PHV, RATER, INTERVIEWER, CraUB];
      return !_.includes(rolesNotInviteParticipants, this.user.userRole);
    },
    processParticipant(allParticipants) {
      if (allParticipants && allParticipants.length == 0) {
        return allParticipants;
      }
      allParticipants.map(participant => {
        if (participant != undefined) {
          if (participant.participantLanguage != undefined) {
            participant.language = participant.participantLanguage.language_id;
          }
        }
        if (!!participant.linkedLanguages == false) {
          participant.linkedLanguages = this.studyData.studyLanguage;
        }

        participant.disabled = true;
        if (participant.status == this.getStatuses.NOTINVITED || participant.status == this.getStatuses.INVITED) {
          participant.disabled = false;
        }
      });

      return allParticipants;
    },
    getNotInvitedUserList(flag) {
      this.notInvitedUsers = [];
      this.$api.getNotInvitedParticipantsFact(this.studyId).then(
        response => {
          response.body.forEach(part => {
            this.notInvitedUsers.push(part);
          });
          if (flag) {
            this.getUniqueNotInvitedUser();
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting not invited participants.");
        }
      );
    },
    populateLanguageOptions(participant) {
      let languagesList = [];
      let linkedLanguages = participant.linkedLC[participant.countryId];
      let approvedLanguages = participant.approvedSiteLanguages[participant.countryId];
      if (participant.linkedLC != undefined && Object.keys(participant.linkedLC).length != 0) {
        if (participant.linkedLC[participant.countryId]) {
          linkedLanguages.forEach(language => {
            if (approvedLanguages.findIndex(e => e.language_id == language.language_id) > -1) {
              languagesList.push(language);
            }
          });
        }
      } else {
        languagesList = this.studyData.studyLanguage;
      }
      if (this.participantsList.indexOf(participant) != -1) {
        this.participantsList[this.participantsList.indexOf(participant)].contryWiseLanguages = languagesList;
      }
    },
    populateCountryOptions(participantObj) {
      let selectedSiteObj = filter(this.researchSites, { id: participantObj.siteId });
      let approvedLanguages = selectedSiteObj[0].approvedSiteLanguages;
      let siteCountries = selectedSiteObj[0].countryList;
      let siteCountryLanguages = selectedSiteObj[0].linkedCountryLanguages;
      participantObj.countrySiteOptions = siteCountries;
      participantObj.linkedLC = siteCountryLanguages;
      participantObj.approvedSiteLanguages = approvedLanguages;
      //If there is only one country associated to the site then set it as default selected country
      this.setDefaultCountry(participantObj, siteCountries);
    },
    populateSiteOptions(participantObj, event) {
      participantObj.siteIdOptions = filter(this.researchSites, { siteSubType: event.target.value });
      participantObj.siteId = null;
      participantObj.countryId = null;
      participantObj.countrySiteOptions = null;
    },
    getSiteDetailsFact() {
      if (this.user.siteIds) {
        let getSiteIdDetails = JSON.parse(window.localStorage.getItem("getSiteIdDetails"));
        if (getSiteIdDetails === null) {
          this.$api.getSiteDetailsFact(this.studyId, this.user.siteIds[0]).then(
            response => {
              window.localStorage.removeItem("getSiteIdDetails");
              window.localStorage.setItem("getSiteIdDetails", JSON.stringify(response.body));
              this.siteDetails = response.body;
              this.researchSites = response.body;
              this.participantsList[0].countrySiteOptions = this.siteDetails.countryList;
              this.participantsList[0].linkedLC = this.siteDetails.linkedCountryLanguages;
              this.setPreferredCountries();
              this.participantsList[0].approvedSiteLanguages = this.siteDetails.approvedSiteLanguages;
              //If there is only one country associated to the site then set it as default selected country
              this.setDefaultCountry(this.participantsList[0], this.siteDetails.countryList);
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
            }
          );
        } else {
          this.siteDetails = getSiteIdDetails;
          this.researchSites = getSiteIdDetails;
          this.participantsList[0].countrySiteOptions = this.siteDetails.countryList;
          this.participantsList[0].linkedLC = this.siteDetails.linkedCountryLanguages;
          this.setPreferredCountries();
          this.participantsList[0].approvedSiteLanguages = this.siteDetails.approvedSiteLanguages;
          //If there is only one country associated to the site then set it as default selected country
          this.setDefaultCountry(this.participantsList[0], this.siteDetails.countryList);
        }
      }
    },
    setDefaultCountry(participantObj, siteCountries) {
      if (siteCountries.length == 1) {
        let languagesList = [];
        //If there is only one country associated to the site then set it as default selected country
        participantObj.countryId = siteCountries[0].countryId;
        participantObj.errorCountry = false;
        let approvedLanguages = participantObj.approvedSiteLanguages[participantObj.countryId];
        let linkedLanguages = participantObj.linkedLC[participantObj.countryId];
        linkedLanguages.forEach(language => {
          if (approvedLanguages.findIndex(e => e.language_id == language.language_id) > -1) {
            languagesList.push(language);
          }
        });
        participantObj.contryWiseLanguages = languagesList;
        this.populateLanguageOptions(participantObj);
      } else {
        participantObj.countryId = null;
        participantObj.errorCountry = true;
      }
    },
    //TUR-61129
    isVerificationFieldInvalid(participant) {
      if (participant.verificationMethod === "email" && participant.email.trim() !== "") {
        participant.emailError = false;
        return false;
      } else if (participant.verificationMethod === "phone" && participant.mobile.trim() !== "" && participant.phoneObject && participant.phoneObject.valid) {
        participant.phoneError = false;
        return false;
      } else {
        return true;
      }
    },
    //TUR-61129
    isNull(v) {
      if (typeof v === "string" || v instanceof String) {
        return v || "";
      }
      return "";
    },
    setFiltersData(pid) {
      let participantFilters = LocalStorageService.getItem("participants-filter-map");
      participantFilters = participantFilters ? new Map(JSON.parse(participantFilters)) : new Map();
      let filters = {
        pageSize: Number(this.selectedShowOption),
        search: this.isNull(this.searchTerm),
        filter: this.isNull(this.filterTerm),
        sortValue: this.isNull(this.sortValue),
        sortOrder: this.isNull(this.sortOrder),
        customKey: this.isNull(this.customKey),
        sourcefilter: this.isNull(this.sourcefilter),
        cohortFilter: this.isNull(this.cohortFilter),
        withdrawnOrFailedFilter: this.isNull(this.withdrawnOrFailedFilter)
      };
      participantFilters.set(this.studyId + "-" + pid, filters);
      LocalStorageService.setItem("participants-filter-map", [...participantFilters]);
    },
    backToComposeMessage() {
      if (LocalStorageService.getItem(this.composeMessageId) === null || LocalStorageService.getItem(this.composeMessageId) === undefined) {
        this.$toastr.error("Something went wrong, please start from the compose process again.");
      } else {
        let comMsgObj = LocalStorageService.getItem(this.composeMessageId);
        comMsgObj.participantList = this.composeParticipants;
        LocalStorageService.setItem(this.composeMessageId, comMsgObj);
        this.$router.push({
          name: "study-participant-compose-message",
          params: { composeMessageId: this.composeMessageId }
        });
      }
    },
    // -------------------------------------
    // |  Activate Selected Participants   |
    // -------------------------------------
    activateForParticipant() {
      /**method selecting participant for the site document */
      let activateForMoreParticipants = this.activateForMoreParticipants ? this.activateForMoreParticipants : false;
      if (!this.siteDocumentId) {
        this.$toastr.error("Something went wrong");
      } else {
        let participantData = {
          participantsList: []
        };
        this.composeParticipants.map(item => {
          participantData["participantsList"].push(item.participantId);
        });
        this.$api.statusChangeStudyCustomDocuement(this.studyId, this.siteDocumentId, true, activateForMoreParticipants, participantData).then(
          response => {
            this.$toastr.success(response.body.message);
            let siteId = this.$route.query.siteId;
            if (siteId) {
              this.$router.go(-1);
            } else {
              this.$router.push({
                name: "study-participant-documents"
              });
            }
          },
          error => {
            toastr.error(error.body ? error.body.message : "Error while activating document");
          }
        );
      }
    },
    activateParticipantsForAll() {
      if (this.allParticipantsSelected) {
        this.currentParticipantsList.map(item => {
          this.composeParticipants.push({ emailId: item.email, participantId: item.id });
        });
        this.selectedParticipantLength = this.currentParticipantsList.length;
      } else {
        this.composeParticipants = [];
      }
    },
    checkIfFixedCharactersAreSame(participant) {
      let isFormatUpdate = false;
      if (!this.studyData) {
        return;
      }
      let fixedCharactersIndex = [];
      let formatArr = JSON.parse(this.studyData.participantIdFormatConfigured.format);
      formatArr.map((ch, index) => {
        if (ch != "" && ch != null) {
          fixedCharactersIndex.push({ index: index, character: ch });
        }
      });

      for (let i = 0; i < fixedCharactersIndex.length; i++) {
        if (fixedCharactersIndex[i].character != participant.userDefinedParticipantId[fixedCharactersIndex[i].index]) {
          isFormatUpdate = true;
          break;
        }
      }
      return isFormatUpdate;
    },
    ifParticipantIDIsRequired(participant) {
      // if participant id is not requred and PID is empty
      if (!this.studyData.isParticipantIdRequired && (participant.userDefinedParticipantId != "" || participant.userDefinedParticipantId != null)) {
        return false;
      }
      return true;
    },
    checkIfParticipantIdFormatHasBeenChanged(element) {
      if (this.studyData && !this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        return false;
      }
      // check user define participant id with latest one.
      // check if size is equal to latest format then only fetch fixed characters
      if ((this.studyData && this.studyData.participantIdFormatConfigured.size) != (element.userDefinedParticipantId && element.userDefinedParticipantId.length)) {
        return this.ifParticipantIDIsRequired(element);
      } else if ((this.studyData && this.studyData.participantIdFormatConfigured.size) == (element.userDefinedParticipantId && element.userDefinedParticipantId.length)) {
        if (!this.checkIfFixedCharactersAreSame(element)) {
          // check for dissallow characters
          if (element.userDefinedParticipantId.length > 0) {
            let charArr = element.userDefinedParticipantId.split("");
            let characters = charArr.filter((ch, index) => {
              if (this.fixedCharactersIndex.indexOf(index) == -1 && ch != null) {
                return ch;
              }
            });
            let PID = characters.join("");
            if (this.studyData.participantIdFormatConfigured.isDisallowLetters && /[a-zA-Z]/g.test(PID)) {
              return true;
            } else if (this.studyData.participantIdFormatConfigured.isDisallowNumbers && /[0-9]/g.test(PID)) {
              return true;
            } else if (this.studyData.participantIdFormatConfigured.isDisallowSpecialCharacters && /[[\\\];=!@#$%^&*(),'_.?":{}|<>+~/`-]/g.test(PID)) {
              return true;
            }
          }
        } else {
          return true;
        }
      }
      return false;
    },
    toggleScheduleModal(value) {
      this.isScheduleStartModalShown = value;
      this.modalStatus = false;
    },
    convertArrayStringHtml(colorCodingMetaDataOld, userDefinedParticipantId) {
      let colorCodingMetaData = colorCodingMetaDataOld;
      let PIDid;
      if (this.studyData.participantIdFormatConfigured.colorCodingEnable) {
        colorCodingMetaData = this.studyData.participantIdColorCodingMetaData;
        PIDid = userDefinedParticipantId.split("");
        for (let i = 0; i <= colorCodingMetaData.length - 1; i++) {
          for (let j = 0; j <= PIDid.length - 1; j++) {
            if (colorCodingMetaData[i].colorCodeCharacter - 1 == j) {
              switch (colorCodingMetaData[i].colorCodeCondition) {
                case "Is equal to":
                  if (colorCodingMetaData[i].colorCodeConditionValue == PIDid[j]) {
                    PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                  }
                  break;
                case "Is not equal to":
                  if (colorCodingMetaData[i].colorCodeConditionValue != PIDid[j]) {
                    PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                  }
                  break;
                case "None":
                  PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                  break;
              }
            }
          }
        }
        let PIDConv = "";
        for (let i = 0; i <= PIDid.length - 1; i++) {
          PIDConv = PIDConv + PIDid[i];
        }
        return PIDConv;
      } else {
        return userDefinedParticipantId;
      }
    },
    getCohortList() {
      this.$api.getcohortList(this.studyId).then(
        response => {
          this.$nextTick(() => {
            this.cohortList = response["body"].length ? response["body"] : [];
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
        }
      );
    },
    addScreenFailure(e) {
      this.selectedScreenFailure = true;
      window.$("#changeScreeningStatus").modal("show");
    },
    hideScreenFailureReasons() {
      this.selectedScreenFailure = false;
      this.screenFailureReasons = [];
      this.showError = false;
      window.$("#changeScreeningStatus").modal("show");
    },
    closeScreenFailureModal() {
      window.$("#screenFailureResons").modal("hide");
    },
    isConfirmButtonDisable() {
      if (this.screenFailureReasons.length > 0 && this.checkOtherReason && !this.otherScreenFailureReasons) {
        return true;
      }
      return false;
    },
    getScreenFailureReasons(data) {
      this.selectedReason = "Screen Failure";
      this.failureReasons = data.screenFailureReasons;
    },
    //61129
    onInputPhoneNumber(number, phoneObject, participant) {
      participant.phoneObject = phoneObject;
    },
    countryChanged(phoneObject, participant) {
      this.phoneValidated(participant.phoneObject, participant);
    },
    phoneValidated(phoneObject, participant) {
      participant.phoneObject = phoneObject;
      if (phoneObject.valid) {
        participant.mobile = this.$options.filters.trim0(phoneObject.number.national);
        participant.mobileCountryCode = phoneObject.country.dialCode;
      }
      this.validateParticipants(this.participantsList.indexOf(participant));
    },
    //61129
    getDiscontinuedReasons(data) {
      this.failureReasons = [];
      this.selectedReason = "Discontinuation";
      this.failureReasons.reasons = data.discontinuationReason.split(",").map(function(item) {
        return item.trim();
      });
      let i = this.failureReasons.reasons.indexOf("Other");
      if (i > -1) {
        this.failureReasons.reasons.splice(i, 1);
      }
      if (data.statusChangeReason != "") {
        this.failureReasons.other = data.statusChangeReason;
      }
    },
    checkLegacyValue() {
      this.$api.getLegacyData(this.studyId).then(response => {
        if (response) {
          this.legacyVal = response.body;
        }
      });
    }
  },
  mounted() {
    document.body.classList.add("participant-custom");
    this.getSiteDetailsFact();
    this.currentSiteId = this.$route.params.siteId;
    this.getAllParticipants(this.selectedShowOption, this.currentPage);
    this.getStudyDetails();
    this.getCohortList();
    this.getCustomLabels();
    this.checkLegacyValue();
    this.getNotInvitedUserList(false);
    this.getToggledFeatures();
    this.participantTransfer = this.$route.params.participantTransfer;
    //verify that the user has come to this page from compose message and the compose id exists in local storage
    if (this.composeMessageId) {
      let comMsgObj = LocalStorageService.getItem(this.composeMessageId);
      if (comMsgObj === null || comMsgObj === undefined) {
        this.composeMessageId = null;
        this.$toastr.error("Something went wrong, please start from the compose process again.");
        this.$router.push({
          name: "study-participant-messages"
        });
      } else {
        if (Object.keys(comMsgObj).length != 0) {
          this.composeParticipants = comMsgObj.participantList;
        }
      }
    }
    this.participantsList[0].verificationMethod = this.studyData.verificationMethod === "both" ? "email" : this.studyData.verificationMethod;
  },
  destroyed() {
    document.body.classList.remove("participant-custom");
  }
};
</script>

<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)

body {
  color: #333;

  .mb-5 {
    margin-bottom: 5px !important;
  }
}

.transfer-buttons {
  right: 10px !important;
}

.cancel-btn {
  margin-right: 10px;
}

#siteIdSelectBox {
  position: relative;
}

//dropdown css
.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px;
  /* width of the entire scrollbar */
}

.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent;
  /* color of the tracking area */
}

.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9;
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid transparent;
  /* creates padding around scroll thumb */
}

.select-scroll {
  scrollbar-width: thin;
  /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent;
  /* scroll thumb & track */
}

.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}

.siteIdModel-2 .modal-dialog {
  width: 339px;
  // max-height: 350px;
  height: auto;
  padding: 24px 18px 32px 17px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #ffffff;
}

.siteIdModel-2 .modal-content {
  box-shadow: none;
  padding: 0 !important;
}

.siteIdModel-2 .modal-body {
  padding: 0 !important;
}

.siteIdModel-2 .question-title {
  margin: 0 2px 17px;
  font-family: RobotoRegular;
  font-size: 18px;
  line-height: 1.33;
  text-align: center;
  color: #4a4a4a;
}

.siteIdModel-2 .note {
  margin: 16px 20px 0;
  font-family: RobotoRegular;
  font-size: 14px;
  line-height: 1.33;
  text-align: center;
  color: #4a4a4a;
}

.siteIdModel-2 .participant-info {
  width: 100%;
  height: 150px !important;
  overflow: auto;
  margin: 0 auto;
  padding: 10px 10px 15px;
  border-radius: 0 imp !important;
  background-color: #f0f3f5d0;
}

#select-question {
  -moz-appearance: none !important;
  appearance: none;
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down.png);
}

.siteId-input .th-comman-select-box {
  color: #4a4a4a !important;
  text-transform: capitalize;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

#showsiteId {
  position: relative;
  top: 0px;
  background: #fff;
  width: 100%;
  height: fit-content;
  border-radius: 4px;
  padding-bottom: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showsiteId label:first-child {
  background-color: #f5f8fa;
}

#showsiteId label {
  font-size: 14px;
  color: #000;
  float: left;
  width: 275px;
  line-height: 30px;
  margin-bottom: 0px;
}

.pi-width {
  width: 100% !important;
  padding: 0 16px !important;
}

.form-control:disabled,
.form-control {
  background-color: #ffffff;
  opacity: 1;
  height: 36px;
  margin-bottom: 15px;
}

#showsiteId label:hover {
  background-color: #f5f8fa;
}

.page-modal {
  position: relative;
  width: 100%;
  height: 200px;
}

.content {
  width: 100%;
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  // overflow-y: scroll;
  overflow-x: hidden;
}

.Site-ID {
  width: 30%;
  font-size: 14px;
  line-height: 1.43;
  color: #666669;
  display: block;
  margin: 13px 0 13px 10px;
  font-family: Roboto;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Site-Name {
  width: 70%;
  margin: 13px 0 13px 10px;
  font-size: 14px;
  line-height: 1.43;
  color: #666669;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.question-answer-style-heading {
  height: 13px;
  font-family: RobotoRegular;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}

.question-answer-style {
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}

.link {
  color: #1e8fe1 !important;
  cursor: pointer;
}

.link:hover {
  color: #1e8fe1;
  text-decoration-line: underline !important;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h4,
h4 {
  font-size: 18px;
  margin: 10px 0;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.table-striped > tbody > tr[data-v-15e213e8]:nth-of-type(odd) {
  background-color: #fff !important;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.modal-content-style {
  padding: 15px;
  width: 477px;
  height: 207px;
  border-radius: 3px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}

.gray-color {
  color: #4a4a4a !important;
}

.purple_color {
  color: #a569bd !important;
}

.siteId-box {
  width: 297px;
  height: 255px !important;
  padding: 10px 5px 14px 5px;
  object-fit: contain;
  border-radius: 4px;
  border: solid 2px #d3dfe4;
  background-color: #ffffff;
}

.invite-que-style {
  font-family: RobotoRegular;
  font-size: 14px;
  color: #666669;
}

.change-screening-status {
  margin: 5px 15px;
  width: auto;
  height: 32px;
  font-family: RobotoRegular;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  color: #666669;
}

.participant-ID {
  margin: 6px 0px 6px 0px;
  width: 76px;
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}

.participant-ID-field {
  margin: 6px 0px 6px 0px;
  width: 78px;
  height: 9px;
  font-family: RobotoRegular;
  font-size: 14px;
  color: #4a4a4a;
}

.thread-ID {
  margin: 6px 0px 6px 0px;
  width: 65px;
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}

.thread-ID-field {
  margin: 6px 0px 6px 0px;
  font-family: RobotoRegular;
  font-size: 14px;
  color: #4a4a4a;
}

.cancel-modal-but {
  border: 1px solid #e0e0e0;
  border-radius: 18px;
  width: 110px;
  height: 36px;
  background-color: #e0e0e0;
}

.cancel-modal-span {
  width: 78px;
  height: 20px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #000000;
}

.screening-failed-but {
  border: 1px solid #f16559;
  border-radius: 18px;
  width: 148px;
  height: 36px;
  background-color: #f16559;
}

.screening-failed-span {
  width: 116px;
  height: 20px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}

.screening-passed-but {
  border: 1px solid #4c8ce4;
  border-radius: 18px;
  width: 147px;
  height: 36px;
  background-color: #4c8ce4;
}

.active-without-app-but {
  border: 1px solid #e0e0e0;
  border-radius: 18px;
  width: auto;
  height: 36px;
  background-color: #e0e0e0;
}

.screening-passed-span {
  width: 115px;
  height: 20px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}

.rectangle {
  display: flex;
  width: auto;
  min-height: 59px;
  background-color: #eaf0f4;
}

.header-rectangle {
  width: 100%;
  height: 44px;
  background-color: #f1f4f8;
}

.eligibility-heading-style {
  width: 100%;
  font-family: RobotoRegular;
  font-size: 16px;
  color: #000000;
  text-align: center;
  padding: 16px;
  border-bottom: 5px solid #f1f4f8;
}

.agreement-accepted-style {
  width: 90%;
  height: 16px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  text-align: end;
}

.eligibility-popup-icon {
  margin-left: 6px;
  margin-bottom: 6px;
  width: 19px;
  height: 19px;
  object-fit: contain;
}

.lang-slection-style {
  margin: 6px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: #4a4a4a;
  background-color: #f1f4f8;
  border: none;
  outline: 0;
}

.lang-slection-style :focus {
  border: none;
  outline: 0;
}

.close-btn {
  width: 28px;
  font-size: 18px;
  line-height: 1;
  color: #4a4a4a;
  font-weight: normal;
  border: 0;
  margin: 10px;
  background-color: #f1f4f8;
}

.loading-style {
  font-family: RobotoRegular;
  font-size: 25px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  left: 20;
  width: 70px;
  height: 25px;
  position: absolute;
  left: 48%;
  top: 50%;
}

.question-wrapper::-webkit-scrollbar {
  width: 6px;
  /* width of the entire scrollbar */
}

.question-wrapper::-webkit-scrollbar-track {
  background: transparent;
  /* color of the tracking area */
}

.question-wrapper::-webkit-scrollbar-thumb {
  background-color: #e6e9ed;
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid transparent;
  /* creates padding around scroll thumb */
}

.question-wrapper {
  overflow-y: scroll;
  height: 485px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  scrollbar-width: thin;
  /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent;
  /* scroll thumb & track */
}

.field-wrapper {
  width: auto;
  padding: 5px 10px;
}

.check-withwrawn {
  vertical-align: middle;
  width: 16.7px;
  height: 16.7px;
}

.margin-style-1 {
  margin: 10px 30px 10px 40px !important;
  border-bottom: 1px solid #e5e5e5;
}

.margin-style-2 {
  margin: 10px 44px 10px 40px !important;
  border-bottom: 1px solid #e5e5e5;
}

.Show-Withdrawn-or-Failed-participants {
  margin-top: 11px;
  margin-bottom: 0;
  height: 14px;
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #000000;
  margin-left: 10px;
  margin-right: 5px;
}

.search-field {
  padding: 8px !important;
  background-image: url("/static/img/search1.svg");
  background-repeat: no-repeat;
  background-position: 97% 50%;
  color: #2d3752;
  border: 1px solid #e4e8eb !important;
}

.select_section {
  select.form-control {
    height: 40px !important;
    line-height: 22px;
  }
}

.participant-form-height .show_section select.form-control {
  height: 36px !important;
  line-height: 22px;
  margin-bottom: 15px;
}

.participant-form-height input.form-control {
  height: 36px;
  margin-bottom: 15px;
}

.transfer-modal-dialog {
  min-width: 31%;
}

.transfer-modal-title {
  clear: both;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: #000000;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }

  .col-sm-12 {
    width: 100%;
  }

  .col-sm-10 {
    width: 83.33333333%;
  }

  .col-sm-4 {
    width: 33.33333333%;
    //max-width: inherit;
  }

  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }

  .col-md-2 {
    width: 16.66666667%;
  }

  .col-md-10 {
    width: 83.33333333%;
  }

  .col-md-12 {
    width: 100%;
  }
}

.trigger-day-btn {
  border-radius: 100px;

  &.cancel {
    background-color: #000;
    color: #fff;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }

  .col-lg-2 {
    width: 16.66666667%;
  }

  .col-lg-10 {
    width: 82.33333333%;
  }

  .col-lg-11 {
    width: 91.66666667%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.main-content {
  width: 100%;
}

.add-invite-btn {
  color: #fff !important;
  background-color: #1e8fe1 !important;
  border-color: #1e8fe1 !important;
}

.yes-btn {
  color: #fff !important;
  background-color: #1e8fe1 !important;
  border-color: #1e8fe1 !important;
  width: 100px !important;
}

.no-btn {
  color: #fff !important;
  background-color: #4a4a4a !important;
  border-color: #4a4a4a !important;
  width: 100px !important;
}

.cancel-btn {
  color: #fff !important;
  background-color: #4a4a4a !important;
  border-color: #4a4a4a !important;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  position: absolute;
  bottom: -3px;
}

.invite-text {
  color: #666669 !important;
}

.send-invite {
  background-color: #f16559;
  color: #fff;
  font-size: 12px;
}

.ml-30 {
  margin-left: 30px;
}

.newBtn {
  height: 36px;
  color: #fff !important;
  background-color: #1e8fe1 !important;
  border-color: #1e8fe1 !important;
  cursor: pointer;
  font-weight: 400;
  padding: 0.375rem 15px;
  /* cursor: pointer; */
  //font-weight: bold;
}

.color_1e8fe1 {
  color: #1e8fe1;
}

.color_f16559 {
  color: #f16559;
}

.importBtn {
  // width: 85px;
  height: 30px;
  border-radius: 4px;
  border: solid 1px #1e8fe1;
  background-color: #ffffff;
  color: #1e8fe1;
  cursor: pointer;
  font-size: 14px;
}

.img-mr {
  margin-top: -2px;
}

.width-650 {
  width: 650px !important;
  min-width: 650px !important;
}

.width-1100 {
  width: 1100px !important;
  min-width: 1100px !important;
}

.width-850 {
  width: 850px !important;
  min-width: 850px !important;
}

.width-700 {
  width: 700px !important;
  min-width: 700px !important;
}

.width-100 {
  width: 100px;
}

.height-250 {
  height: 250px;
}

.height-auto {
  height: auto !important;
}

.participant-bg {
  background: #f5f8fa !important;
  // height: 100%;
  // min-height: 100vh;
  color: #34537d;
  overflow: auto;

  h3 {
    color: #34537d;
  }
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f5f8fa !important;
}

.table {
  .heading-color {
    color: #9b9b9b !important;
    border-top: none;
    border-bottom: none;
    vertical-align: top;
  }

  th,
  td {
    padding: 10px;
    line-height: 30px;
    word-break: break-all;
  }
}

.table-border {
  border-bottom: 1px solid #e4e8eb !important;
}

.new-label-width {
  min-width: 300px !important;
}

.invite-width {
  min-width: 250px !important;
}

.table-content-color {
  color: #4a4a4a;
  height: 55px !important;
}

.azure-class {
  color: #1f95f2;
}

.modal-content {
  padding: 15px;
}

.table-column {
  width: 100%;
  background-color: #fff;
  height: 100%;
  padding: 18px 0px 0px 0px;
  color: #9b9b9b;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.color_import {
  color: #34537d;
  padding-bottom: 30px;
}

.input-bg {
  background: #ffffff !important;
  color: #4a4a4a !important;
  border: 1px solid #e4e8eb !important;
}

.icon-bg {
  color: #ffffff;
}

.icon-color {
  color: #34537d;
}

.fs-14 {
  font-size: 14px !important;
}

.view-color {
  color: #00b1ff;
  cursor: pointer;
}

.close-style {
  position: relative;
  right: 8px;
  top: 5px;
  font-size: 28px;
}

.footer-close-style {
  color: #34537d;
  margin-bottom: 15px;
  text-align: center;
  cursor: pointer;
}

.lh-15 {
  line-height: 15px;
}

.download-style {
  color: #00baf9;
  text-align: center;
  font-size: 16px;
  padding-bottom: 20px;
}

.file-style {
  color: #2ecc71;
  text-align: center;
  font-size: 16px;
  padding-bottom: 20px;
}

.modal-title {
  color: #34537d;
  padding: 10px 0;
  font-size: 24px;
}

.number-color {
  color: #ffa5a8 !important;
}

.modal-style {
  padding: 0;
  font-size: 16px;
  padding-bottom: 30px;
}

.modal-w-h-style {
  scroll-behavior: smooth;
  width: 700px;
  border-radius: 2px;
  max-height: calc(104vh - 5.063rem);
  overflow-y: auto;
  background-color: #ffffff;
  left: -10%;
  margin-top: 0% !important;
}

.modal-info {
  color: #535456;
}

.color_2d3752 {
  color: #2d3752;
}

.color_4a4a4a {
  color: #4a4a4a;
}

.color_e74c3c {
  color: #e74c3c;
}

.bb-e4e8eb {
  border-bottom: 1px solid #e4e8eb;
}

.download-modal {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.link-color {
  color: #1d7fee !important;
}

.participant_content modal-dialog {
  width: 500px;
}

.file-upload-participant {
  border: none;
  border-radius: 30px;
  height: 100%;
  background-color: #34537d !important;
  margin-bottom: 10px;
  display: block;
  width: 100% !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.select_control {
  background-repeat: no-repeat;
  border: none;
}

.label-icon {
  border-radius: 3px;
  font-size: 16px;
  background-color: #e2e8ee;
  padding: 2px 6px;
}

.table .trigger:hover {
  background-color: #e2e8ee;
  border-radius: 3px;

  .edit {
    display: inline;
    top: 8px;
    left: 15px;
  }
}

.table .trigger2:hover {
  background-color: #e2e8ee;
  border-radius: 3px;

  .edit {
    display: inline;
    top: 8px;
    left: 4px;
  }
}

.pb-90 {
  padding-bottom: 90px !important;
}

.edit {
  padding: 0px;
  display: none;
  font-size: 16px;
  cursor: pointer;
}

.first {
  position: absolute;
  width: 200px;
  left: 0;
  line-height: 20px !important;
  padding: 10px !important;
  max-width: 200px !important;
}

.wrapper {
  overflow: auto;
}

.wrapper::-webkit-scrollbar {
  width: 6px;
  /* width of the entire scrollbar */
}

.wrapper::-webkit-scrollbar-track {
  background: transparent;
  /* color of the tracking area */
}

.wrapper::-webkit-scrollbar-thumb {
  background-color: #c5d1d6;
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid transparent;
  /* creates padding around scroll thumb */
}

@media (max-width: 575px) {
  .xs-none {
    display: none;
  }

  .xs-pl-0 {
    padding-left: 0px;
  }

  .mob-pt15 {
    padding-top: 15px;
  }
}

@media (max-width: 1024px) {
  .modal-w-h-style {
    margin-left: -100% !important;
    margin-top: -85% !important;
  }
}

@media (max-width: 1199px) {
  .has-sidemenu .container {
    padding-left: 30px !important;
    padding-right: 30px !important;
    width: auto;
    max-width: inherit;
  }
}

.modal-header,
.modal-title {
  padding: 0 !important;
}

.select_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #1f8fe1;
  right: 25px;
  top: 10px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  /* border-left: 1px solid #0ebeff; */
  position: absolute;
  pointer-events: none;
}

.show_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #1e8fe1;
  right: 10px;
  top: 8px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  position: absolute;
  pointer-events: none;
}

.show_section.siteId:after,
.show_section.country:after,
.show_section.langugage:after,
.show_section.siteSubType:after,
.show_section.verificationMethod:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  right: 25px;
  top: 40px;
  position: absolute;
}

.lh-36 {
  line-height: 36px;
}

.width-80 {
  width: 80px !important;
}

.height-500 {
  min-height: 600px !important;
}

.sortDown {
  position: absolute;
  padding-left: 4px;
  padding-top: 3px;
}

.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
}

.position-relative {
  position: relative;
}

.dropdown-toggle::after {
  display: none;
}

.line-height {
  line-height: 1.5;
}

.pt-150 {
  padding-top: 150px;
}

.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: auto;
  min-width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
}

.display-inline-flex {
  display: inline-flex !important;
}

.position-absolute {
  position: absolute;
}

.position-relative {
  position: relative;
}

.bottom-0 {
  bottom: 0px;
}

#download-report-modal.modal.show {
  overflow-x: hidden;
  overflow-y: auto;
}

body.modal-open {
  overflow: hidden;
}

/* Hide the browser's default checkbox */
.Show-Withdrawn-or-Failed-participants input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.Show-Withdrawn-or-Failed-participants .checkmark {
  position: absolute;
  top: 10px;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #fff;
  border: 1px solid #dedede;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.Show-Withdrawn-or-Failed-participants:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.Show-Withdrawn-or-Failed-participants input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.Show-Withdrawn-or-Failed-participants input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.Show-Withdrawn-or-Failed-participants .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.select-participant {
  /*checkbox data*/
  input[type="checkbox"] + span {
    display: block;
  }

  input[type="checkbox"] {
    display: none;
    height: 16px;
    width: 16px;
  }

  input[type="checkbox"] + span:before {
    content: "\f00c";
    border: 0.1em solid #d3dfe4;
    border-radius: 3px;
    width: 16px;
    height: 16px;
    padding: 3px;
    color: transparent;
    background-color: #fff;
    font-size: 10px;
    font: normal normal normal 10px/1 FontAwesome;
  }

  input[type="checkbox"]:checked + span:before {
    background-color: #4c8ce4;
    border: 0.1em solid #4c8ce4;
    color: #fff;
    font-size: 10px;
  }
}

.back-to-compose {
  button {
    font-weight: normal;
    width: auto;
    height: auto;
    padding: 7px 10px;
  }
}

.compose-part-sel-text {
  color: #979797;
  font-size: 14px;
  font-family: RobotoRegular;
  margin-left: 35px;
  font-weight: normal;
}

.participant-breadcrumb {
  height: auto;
  width: auto;
  background-color: transparent;

  .breadcrumb {
    padding: 17px 30px;
    padding-bottom: 9px;
    background-color: transparent;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
    list-style: none;
    border-radius: 0.25rem;

    .breadcrumb-item {
      color: #4a4a4a;

      a {
        color: #4c8ce4;
        cursor: pointer;
      }

      &.current-label {
        color: #9b9b9b;
        cursor: text;
      }
    }
  }
}

.activeModificationBlock {
  width: 120px;
  height: 10px;
  background-color: #cccccc;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 2px;
}

.modifiedText {
  color: #ffffff;
  opacity: 0.7;
  font-size: 11px;
}

.information {
  background-color: #eaf0f4;

  .modal-heading {
    font-weight: 600;
  }
}

.draft-lang {
  display: none;
}

.btn-cancel-default {
  background-color: transparent;
  font-weight: 500;
}

.btn-continue-prim {
  width: 110px;
  margin: 0 0 0 10px;
  background-color: #4c8ce4;
}

#showSiteTransferReason {
  background: #fff;
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: fit-content;
  border-radius: 4px;
  overflow: hidden;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showSiteTransferReason label {
  float: left;
  line-height: 30px;
  margin-bottom: 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  color: #666669;
}

#showSiteTransferReason label:hover,
#showLanguageDrop label:hover {
  background-color: #f5f8fa;
}

.btn-1 {
  padding: 6px 35px;
  color: #666669;
  background-color: #e3e3e3;
}

.btn-2 {
  padding: 6px 35px;
  color: #ffffff;
  background-color: #4c8ce4;
}

.text-lGray {
  color: #959fa4;
}

.Participant-email-ad-text {
  font-size: 15px;
  font-weight: bold;
  line-height: 1.33;
  text-align: left;
  color: #4a4a4a;
}

@media (min-width: 576px) {
  .resend-invite-modal1.modal-dialog {
    min-width: 738px;
    margin: 1.75rem auto;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .add_part-btn {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .mob-pt15 {
    text-align: left !important;
    padding-left: 0 !important;
  }
}

.screen-failure-popup-icon {
  width: 16px;
  object-fit: contain;
}

.screen-failure {
  height: auto;
  width: 424px;
  margin: 9px 13px 6px 0;
  // padding: 10px 96px 51px 16px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
}

.failure-reasons {
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #000;
  line-height: 2.14;
}

.other-failure-reasons {
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #666669;
  line-height: 1.5;
  margin: 0px;
  padding-bottom: 5px;
  white-space: pre-wrap;
  width: 365px;
}

.failure-reasons ul {
  margin: 0px;
  padding: 10px 76.7px 10px 32.4px;
}

.disable-confirm {
  border: 1px solid #98baeb;
  border-radius: 18px;
  width: 147px;
  height: 36px;
  background-color: #98baeb;
}

.error {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 0;
  padding-left: 0;
}

.input-group {
  position: relative;
}

.input-text-area::after {
  content: "*";
  position: absolute;
  top: 5px;
  left: 170px;
  color: #f00;
}

.multi-reasons-list {
  font-weight: bold;
  color: #000000;
  font-size: 14px;
  font-family: RobotoRegular;
}

.participant-static-text {
  font-weight: bold;
  color: #666669;
  font-size: 14px;
  font-family: Roboto-Medium;
  text-align: center;
  line-height: 22px;
  width: 425px;
}

.reasons-modal-title {
  font-weight: bold;
  width: auto;
  height: 19px;
  margin: 8px 239px 9px 0;
  font-family: Roboto-Regular;
  font-size: 16px;
  text-align: left;
  color: #000;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .add_part-btn {
    margin-top: 10px;
    margin-left: 0 !important;
  }

  .mob-pt15 {
    text-align: left !important;
    padding-left: 0 !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .width-850 {
    width: 750px !important;
    min-width: 750px !important;
  }

  .width-1100 {
    width: 750px !important;
    min-width: 750px !important;
  }

  .pl-30.pr-30.pt-30 {
    padding-left: 20px !important;
  }

  .col.mb-10.text-color.font-weight-bold {
    white-space: nowrap;
    width: 176px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (min-width: 992px) and (max-width: 1111px) {
  .width-850 {
    width: 750px !important;
    min-width: 750px !important;
  }

  .width-1100 {
    width: 990px !important;
    min-width: 990px !important;
  }

  .pl-30.pr-30.pt-30 {
    padding-left: 0px !important;
  }

  .ipad_pad_0 {
    padding: 30px 0px !important;
  }

  .col.mb-10.text-color.font-weight-bold {
    white-space: nowrap;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.col-md-1_5 {
  width: 12% !important;
}

.participant-btn-width {
  padding-top: 15px;
  display: flex;
  padding-left: 0;
}

.err-position {
  position: initial;
}

.tooltip-anchor {
  font-size: 13px;
  font-weight: bold;
  line-height: 1.69;
  text-align: left;
  color: #4c8ce4;
}
</style>
<style scoped lang="scss" src="@/assets/otp-input.scss"></style>
<style lang="scss">
.participant-custom {
  .bs-tooltip-bottom,
  .bs-tooltip-auto[x-placement^="bottom"] {
    padding: 14.2px 0;

    .arrow::before {
      border-width: 0 14.2px 14.2px;
      width: 32px;
      height: 14.2px;
      border-bottom-color: #212b36;
    }
  }

  .tooltip .arrow {
    width: 32px;
    height: 14.2px;
    right: 39px;
    left: unset !important;
  }

  .tooltip-inner,
  .tooltip {
    width: 370px;
    max-width: 370px;
    border-radius: 12px;
    opacity: 1;
  }

  .tooltip-inner {
    padding: 24px 22px;
    background-color: #212b36;
  }

  h6 {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #fff;
    margin-bottom: 16px;
  }

  .tooltip-desc-container {
    margin-bottom: 24px;
  }

  hr {
    border-top: 1px solid rgba(255, 255, 255, 0.25);
  }

  .text-desc {
    font-size: 14px;
    line-height: 1.43;
    text-align: left;
    color: rgba(255, 255, 255, 0.9);
  }

  .text-anchor {
    color: rgba(121, 177, 255, 0.9) !important;
    text-decoration: underline !important;
  }
}
</style>
